//***************************** */
//* Variant Selector
//***************************** */
(() => {
  const GUARD = "__silaba_gallery_sync_v9__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const DEBUG = false;
  const log = (...a) => DEBUG && console.log("[SILABA SYNC]", ...a);

  function getScope(el) {
    // If someone passed an Event, use its target
    if (el && el.target) el = el.target;

    // If someone passed a jQuery object, unwrap it
    if (el && el.jquery) el = el[0];

    // If someone passed an array / NodeList, use first item
    if (Array.isArray(el) || (el && typeof el.length === "number" && !el.nodeType)) {
      el = el[0];
    }

    // If it's not an Element (or doesn't support closest), bail out safely
    if (!el || typeof el.closest !== "function") return document;

    return (
      el.closest('section[data-section-type="product"]') ||
      el.closest("product-rerender") ||
      document
    );
  }

 // Safe helper: always returns an Element (or null)
  function asElement(x) {
    // Event -> element
    if (x && x.target) x = x.currentTarget || x.target;

    // Document -> documentElement
    if (x && x.nodeType === 9) return x.documentElement;

    // Text node -> parent element
    if (x && x.nodeType === 3) return x.parentElement;

    // Element
    if (x && x.nodeType === 1) return x;

    return null;
  }

  function cleanTokenFromUrl(url) {
    if (!url) return null;
    let u = String(url);
    u = u.split("?")[0];
    u = u.replace(/^https?:/i, "");
    const file = (u.split("/").pop() || "").toLowerCase();
    if (!file) return null;

    // remove Shopify size suffixes (_120x, _1024x, _800x800)
    let base = file
      .replace(/_\d+x\d*(?=\.)/i, "")
      .replace(/_\d+x(?=\.)/i, "");

    // drop extension
    base = base.replace(/\.(jpg|jpeg|png|webp|gif)$/i, "");
    return base || null;
  }

  function normalizeEuroPriceText(text) {
    return String(text || "")
      .replace(/([+-])\s*€\s*([0-9][0-9.\s]*(?:,\d{2})?)/g, "$1$2 €")
      .replace(/€\s*([+-]?[0-9][0-9.\s]*(?:,\d{2})?)\s*EUR\b/gi, "$1 €")
      .replace(/€\s*([+-]?[0-9][0-9.\s]*(?:,\d{2})?)/g, "$1 €")
      .replace(/([+-]?[0-9][0-9.\s]*(?:,\d{2})?)\s*EUR\b/gi, "$1 €")
      .replace(/\s{2,}/g, " ")
      .trim();
  }

  function normalizeVisiblePriceElement(el) {
    if (!el || !el.isConnected || el.closest(".visually-hidden")) return;

    const hidden = el.querySelector(":scope > .visually-hidden");

    if (hidden) {
      const visibleText = Array.from(el.childNodes)
        .filter((node) => !(node.nodeType === 1 && node.classList && node.classList.contains("visually-hidden")))
        .map((node) => node.textContent || "")
        .join(" ")
        .trim();

      const normalized = normalizeEuroPriceText(visibleText);
      if (normalized && normalized !== visibleText) {
        el.innerHTML = hidden.outerHTML + normalized;
      }
      return;
    }

    const current = (el.textContent || "").trim();
    const normalized = normalizeEuroPriceText(current);
    if (normalized && normalized !== current) {
      el.textContent = normalized;
    }
  }

  function normalizeVisiblePrices(root) {
    const selector = [
      ".price",
      ".cart-recap__price-line-price",
      ".mini-cart__recap-price-line span:last-child",
      ".line-item__price",
      ".line-item__line-price",
      ".order-foot__item-value",
      ".search-bar__item-price",
      ".unit-price-measurement__price",
      "[data-slb-price-min-label]",
      "[data-slb-price-max-label]",
      ".promo-block__price--sale",
      ".promo-block__price--compare",
      ".mosaic-lookbook__price--sale",
      ".mosaic-lookbook__price--compare"
    ].join(", ");

    if (root && root.matches && root.matches(selector)) {
      normalizeVisiblePriceElement(root);
    }

    (root || document).querySelectorAll?.(selector).forEach(normalizeVisiblePriceElement);
  }

  let normalizePricesFrame = 0;
  function scheduleNormalizeVisiblePrices() {
    if (normalizePricesFrame) cancelAnimationFrame(normalizePricesFrame);
    normalizePricesFrame = requestAnimationFrame(() => {
      normalizeVisiblePrices(document);
      normalizePricesFrame = 0;
    });
  }

  function scoreTokenMatch(candidateToken, targetToken) {
    if (!candidateToken || !targetToken) return 0;
    if (candidateToken === targetToken) return 30; // exact
    if (candidateToken.includes(targetToken)) return 20; // candidate contains target
    if (targetToken.includes(candidateToken)) return 10; // target contains candidate (less specific)
    return 0;
  }

  function pickBestByToken(elements, getTokensFn, targetToken) {
    let bestEl = null;
    let bestScore = 0;
    let bestLen = 0;

    for (const el of elements) {
      const toks = (getTokensFn(el) || []).filter(Boolean);
      for (const t of toks) {
        const s = scoreTokenMatch(t, targetToken);
        const l = t.length;
        if (s > bestScore || (s === bestScore && l > bestLen)) {
          bestScore = s;
          bestLen = l;
          bestEl = el;
        }
      }
    }
    return bestEl;
  }


  function labelToToken(label) {
    const img = label.querySelector("img");
    const src = img?.getAttribute("src") || img?.src || null;
    return cleanTokenFromUrl(src);
  }

  function labelText(label) {
    return (
      label.getAttribute("title") ||
      (label.querySelector(".visually-hidden")?.textContent || "").trim() ||
      label.textContent.trim()
    );
  }

  function isUnavailableSwatchLabel(label) {
    if (!label) return false;

    const wrapper = label.closest(".variant-swatch, .color-swatch, .block-swatch");
    const input = label.htmlFor ? label.ownerDocument.getElementById(label.htmlFor) : null;

    return Boolean(
      input?.disabled ||
      label.matches(".is-unavailable, [data-slb-unavailable]") ||
      wrapper?.matches(".is-unavailable, [data-slb-unavailable], .variant-swatch--disabled, .color-swatch--disabled, .block-swatch--disabled")
    );
  }

  function updateSelectedValue(label, valueText) {
    const opt = label.closest(".product-form__option");
    if (!opt) return;
    opt.querySelectorAll(".product-form__selected-value").forEach((el) => {
      el.textContent = valueText;
    });
  }

  
  function findThumbByToken(scope, token) {
    if (!token) return null;
    const thumbs = Array.from(scope.querySelectorAll(".product-gallery__thumbnail"));
    if (!thumbs.length) return null;

    return pickBestByToken(
      thumbs,
      (a) => {
        const href = a.getAttribute("href") || "";
        const img = a.querySelector("img");
        const src = img?.getAttribute("src") || img?.src || "";
        return [cleanTokenFromUrl(href), cleanTokenFromUrl(src)];
      },
      token
    );
  }

  function selectedGalleryMediaId(scope) {
    const selected = scope.querySelector(".product-gallery__carousel-item.is-selected:not(.is-filtered)");
    return selected ? selected.getAttribute("data-media-id") : "";
  }

  function activateThumb(scope, thumb) {
    if (!thumb || thumb.classList.contains("is-filtered")) return;

    const mediaId = thumb.getAttribute("data-media-id");
    if (mediaId && selectedGalleryMediaId(scope) === mediaId) {
      thumb.classList.add("is-nav-selected");
      return;
    }

    // Let the theme's gallery handler own the transition. Double-dispatching causes Safari flicker.
    thumb.click();
  }

  function getCheckedSwatchLabel(scope) {
    const checked =
      scope.querySelector('.product-form__single-selector[type="radio"]:checked') ||
      null;
    if (!checked?.id) return null;
    const label = scope.querySelector(`label[for="${CSS.escape(checked.id)}"]`);
    return isUnavailableSwatchLabel(label) ? null : label;
  }

  function syncFromLabel(label) {
    if (isUnavailableSwatchLabel(label)) return;

    const scope = getScope(label);
    const token = labelToToken(label);
    const txt = labelText(label);

    log("label", txt, "token", token);

    if (txt) updateSelectedValue(label, txt);

    if (token) {
      const thumb = findThumbByToken(scope, token);
      if (thumb) activateThumb(scope, thumb);
      else log("no thumb for token", token);
    }
  }

  function syncFromScope(scope) {
    const label = getCheckedSwatchLabel(scope);
    if (label) syncFromLabel(label);
  }

  function schedule(elOrScope) {
    const scope = elOrScope.nodeType ? getScope(elOrScope) : elOrScope;
    setTimeout(() => syncFromScope(scope), 140);
    setTimeout(() => syncFromScope(scope), 360);
  }

  // Swatch clicks (works in PT + EN because it uses the swatch image filename)
  document.addEventListener(
    "click",
    (e) => {
      const anySwatchLabel = e.target.closest("label.variant-swatch__item, label.color-swatch__item, label.block-swatch__item");
      if (isUnavailableSwatchLabel(anySwatchLabel)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      const label = e.target.closest("label.variant-swatch__item");
      if (label) {
        setTimeout(() => syncFromLabel(label), 140);
      }
    },
    true
  );

  // Any variant changes (e.g., select[name=id] in the no-js block)
  document.addEventListener(
    "change",
    (e) => {
      const t = e.target;
      if (!t) return;

      if (
        t.matches('select[name="id"]') ||
        t.matches('.product-form__single-selector[type="radio"]')
      ) {
        schedule(t);
      }
    },
    true
  );

  // initial
  window.addEventListener("load", () => schedule(document));
})();

(() => {
  const GUARD = "__silaba_sku_search_submit_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  function normalizeSkuSearchTerm(value) {
    const raw = String(value || "").trim();
    const skuCandidate = raw.replace(/^variants\.sku:/i, "").replace(/\*+$/g, "");

    if (/^(?:[a-z]{1,4}\d[\w.-]*|\d{5,})$/i.test(skuCandidate)) {
      return `variants.sku:${skuCandidate}*`;
    }

    return raw;
  }

  function isSearchForm(form) {
    const action = form.getAttribute("action") || "";

    try {
      const actionUrl = new URL(action, window.location.origin);
      const searchPath = String(window.routes?.searchUrl || "/search").replace(/\/+$/g, "");
      return actionUrl.pathname.replace(/\/+$/g, "") === searchPath;
    } catch (error) {
      return action.indexOf("/search") !== -1;
    }
  }

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!isSearchForm(form)) return;
    if (form.closest(".header__search-bar-wrapper")) return;

    const input = form.querySelector('input[name="q"]:not([type="hidden"]), textarea[name="q"], input[data-slb-visible-search-q], textarea[data-slb-visible-search-q]');
    if (!input) return;

    const normalizedTerm = normalizeSkuSearchTerm(input.value);
    const previousHidden = form.querySelector('input[data-slb-normalized-search-q]');

    if (normalizedTerm === String(input.value || "").trim()) {
      previousHidden?.remove();
      input.setAttribute("name", "q");
      input.removeAttribute("data-slb-visible-search-q");
      return;
    }

    input.removeAttribute("name");
    input.setAttribute("data-slb-visible-search-q", "");

    const hiddenInput = previousHidden || document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "q";
    hiddenInput.value = normalizedTerm;
    hiddenInput.setAttribute("data-slb-normalized-search-q", "");

    if (!previousHidden) {
      input.insertAdjacentElement("afterend", hiddenInput);
    }
  });
})();

/* ========================================================================== */
/* SÍLABA - Keep customer VAT/client type in cart note attributes for sync      */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_customer_cart_attributes_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  function getCustomerCartAttributes() {
    const customer = window.silabaCustomer || {};
    if (!customer.loggedIn) return null;

    const attributes = {};

    if (customer.vatNumber) {
      attributes.vat_number = String(customer.vatNumber).trim();
    }

    if (customer.clientType) {
      attributes.client_type = String(customer.clientType).trim();
    }

    return Object.keys(attributes).length ? attributes : null;
  }

  async function syncCustomerCartAttributes(options = {}) {
    const attributes = getCustomerCartAttributes();
    if (!attributes) return;

    const storageKey = `silaba-cart-attributes:${JSON.stringify(attributes)}`;
    if (!options.force && window.sessionStorage.getItem(storageKey) === "1") return;

    try {
      const cartUrl = window.routes?.cartUrl || "/cart";
      const response = await fetch(`${cartUrl}/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ attributes })
      });

      if (response.ok) {
        window.sessionStorage.setItem(storageKey, "1");
      }
    } catch (error) {
    }
  }

  window.SilabaSyncCustomerCartAttributes = syncCustomerCartAttributes;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => syncCustomerCartAttributes(), { once: true });
  } else {
    syncCustomerCartAttributes();
  }
})();

/* ========================================================================== */
/* SÍLABA - Keep classic account registration note fields in sync              */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_classic_account_note_fields_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  function syncClientType(form) {
    const select = form.querySelector("[data-client-type-select]");
    if (!select) return;

    const codeInput = form.querySelector("[data-client-type-code]");
    const labelInput = form.querySelector("[data-client-type-label]");
    const selectedOption = select.options[select.selectedIndex];
    const value = selectedOption && selectedOption.value ? selectedOption.value.trim() : "";
    const label = selectedOption && selectedOption.value ? selectedOption.textContent.trim() : "";

    if (codeInput) codeInput.value = value;
    if (labelInput) labelInput.value = label;
  }

  function syncVatNumber(form) {
    const source = form.querySelector("[data-vat-number-source]");
    const copy = form.querySelector("[data-vat-number-copy]");
    if (!source || !copy) return;

    copy.value = source.value.trim();
  }

  function syncForm(form) {
    if (!form) return;

    syncClientType(form);
    syncVatNumber(form);
  }

  function syncAll(root = document) {
    root.querySelectorAll("#create_customer").forEach(syncForm);
  }

  document.addEventListener("change", (event) => {
    const field = event.target;
    if (!(field instanceof Element)) return;
    if (!field.matches("[data-client-type-select], [data-vat-number-source]")) return;

    syncForm(field.closest("form"));
  });

  document.addEventListener("input", (event) => {
    const field = event.target;
    if (!(field instanceof Element) || !field.matches("[data-vat-number-source]")) return;

    syncForm(field.closest("form"));
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== "create_customer") return;

    syncForm(form);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => syncAll(), { once: true });
  } else {
    syncAll();
  }
})();

/* ========================================================================== */
/* SÍLABA - Custom selects                                                     */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_mobile_custom_select_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const SELECTOR = "select[data-silaba-custom-select]";
  const PHONE_COUNTRY_SELECTOR = "select[data-silaba-phone-country-select]";
  const PHONE_COUNTRY_DATA = "af:93,ax:358,al:355,dz:213,as:1,ad:376,ao:244,ai:1,ag:1,ar:54,am:374,aw:297,ac:247,au:61,at:43,az:994,bs:1,bh:973,bd:880,bb:1,by:375,be:32,bz:501,bj:229,bm:1,bt:975,bo:591,ba:387,bw:267,br:55,io:246,vg:1,bn:673,bg:359,bf:226,bi:257,kh:855,cm:237,ca:1,cv:238,bq:599,ky:1,cf:236,td:235,cl:56,cn:86,cx:61,cc:61,co:57,km:269,cg:242,cd:243,ck:682,cr:506,ci:225,hr:385,cu:53,cw:599,cy:357,cz:420,dk:45,dj:253,dm:1,do:1,ec:593,eg:20,sv:503,gq:240,er:291,ee:372,sz:268,et:251,fk:500,fo:298,fj:679,fi:358,fr:33,gf:594,pf:689,ga:241,gm:220,ge:995,de:49,gh:233,gi:350,gr:30,gl:299,gd:1,gp:590,gu:1,gt:502,gg:44,gn:224,gw:245,gy:592,ht:509,hn:504,hk:852,hu:36,is:354,in:91,id:62,ir:98,iq:964,ie:353,im:44,il:972,it:39,jm:1,jp:81,je:44,jo:962,kz:7,ke:254,ki:686,xk:383,kw:965,kg:996,la:856,lv:371,lb:961,ls:266,lr:231,ly:218,li:423,lt:370,lu:352,mo:853,mg:261,mw:265,my:60,mv:960,ml:223,mt:356,mh:692,mq:596,mr:222,mu:230,yt:262,mx:52,fm:691,md:373,mc:377,mn:976,me:382,ms:1,ma:212,mz:258,mm:95,na:264,nr:674,np:977,nl:31,nc:687,nz:64,ni:505,ne:227,ng:234,nu:683,nf:672,kp:850,mk:389,mp:1,no:47,om:968,pk:92,pw:680,ps:970,pa:507,pg:675,py:595,pe:51,ph:63,pl:48,pt:351,pr:1,qa:974,re:262,ro:40,ru:7,rw:250,ws:685,sm:378,st:239,sa:966,sn:221,rs:381,sc:248,sl:232,sg:65,sx:1,sk:421,si:386,sb:677,so:252,za:27,kr:82,ss:211,es:34,lk:94,bl:590,sh:290,kn:1,lc:1,mf:590,pm:508,vc:1,sd:249,sr:597,sj:47,se:46,ch:41,sy:963,tw:886,tj:992,tz:255,th:66,tl:670,tg:228,tk:690,to:676,tt:1,tn:216,tr:90,tm:993,tc:1,tv:688,vi:1,ug:256,ua:380,ae:971,gb:44,us:1,uy:598,uz:998,vu:678,va:39,ve:58,vn:84,wf:681,eh:212,ye:967,zm:260,zw:263"
    .split(",")
    .map((item) => {
      const [iso, dial] = item.split(":");
      return { iso, dial };
    });
  const phoneCountryCache = new Map();

  function currentLocale() {
    return window.Shopify?.locale || document.documentElement.lang || navigator.language || "pt";
  }

  function searchLocaleRoot() {
    const value = String(currentLocale() || "pt").toLowerCase();
    if (value.startsWith("es")) return "es";
    if (value.startsWith("en")) return "en";
    return "pt";
  }

  function normalizeSearch(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  function countryNameFor(iso, displayNames) {
    try {
      return displayNames.of(iso.toUpperCase()) || iso.toUpperCase();
    } catch (error) {
      return iso.toUpperCase();
    }
  }

  function flagFor(iso) {
    const upper = String(iso || "").toUpperCase();
    if (!/^[A-Z]{2}$/.test(upper)) return "🌐";
    return Array.from(upper).map((char) => String.fromCodePoint(127397 + char.charCodeAt(0))).join("");
  }

  function phoneCountries() {
    const locale = currentLocale();
    if (phoneCountryCache.has(locale)) return phoneCountryCache.get(locale);

    const displayNames = typeof Intl !== "undefined" && Intl.DisplayNames
      ? new Intl.DisplayNames([locale], { type: "region" })
      : null;
    const englishDisplayNames = typeof Intl !== "undefined" && Intl.DisplayNames
      ? new Intl.DisplayNames(["en"], { type: "region" })
      : null;
    const countries = PHONE_COUNTRY_DATA.map((country) => {
      const name = displayNames ? countryNameFor(country.iso, displayNames) : country.iso.toUpperCase();
      const englishName = englishDisplayNames ? countryNameFor(country.iso, englishDisplayNames) : "";
      const code = `+${country.dial}`;
      const flag = flagFor(country.iso);

      return {
        ...country,
        code,
        flag,
        name,
        label: `${flag} ${code} ${name}`,
        search: normalizeSearch(`${name} ${englishName} ${country.iso} ${code} ${country.dial}`)
      };
    }).sort((first, second) => first.name.localeCompare(second.name, locale, { sensitivity: "base" }));

    const portugalIndex = countries.findIndex((country) => country.iso === "pt");
    if (portugalIndex > 0) {
      countries.unshift(countries.splice(portugalIndex, 1)[0]);
    }

    phoneCountryCache.set(locale, countries);
    return countries;
  }

  function parseStoredPhone(value) {
    const raw = String(value || "").trim();
    const digits = raw.replace(/\D/g, "");
    const fallback = { code: "+351", number: raw.startsWith("+351") ? digits.slice(3) : digits };
    if (!raw || !raw.startsWith("+") || !digits) return fallback;

    const country = phoneCountries()
      .filter((candidate) => digits.startsWith(candidate.dial))
      .sort((first, second) => second.dial.length - first.dial.length)[0];

    if (!country) return fallback;

    return {
      code: country.code,
      number: digits.slice(country.dial.length)
    };
  }

  function populatePhoneCountrySelect(select) {
    if (!select.matches(PHONE_COUNTRY_SELECTOR) || select.dataset.silabaPhoneCountriesReady === "1") return;

    select.dataset.silabaPhoneCountriesReady = "1";
    const parsedPhone = parseStoredPhone(select.getAttribute("data-current-phone"));
    const fragment = document.createDocumentFragment();
    let selectedIndex = 0;

    phoneCountries().forEach((country, index) => {
      const option = document.createElement("option");
      option.value = country.code;
      option.textContent = country.label;
      option.dataset.iso = country.iso;
      option.dataset.search = country.search;
      fragment.appendChild(option);

      if (country.code === parsedPhone.code && selectedIndex === 0) {
        selectedIndex = index;
      }
    });

    select.replaceChildren(fragment);
    select.selectedIndex = selectedIndex;

    const phoneNumberInput = select.closest(".slb-account-phone-fields")?.querySelector("[data-silaba-phone-number]");
    if (phoneNumberInput && parsedPhone.number) {
      phoneNumberInput.value = parsedPhone.number.replace(/\D/g, "");
      phoneNumberInput.classList.add("is-filled");
    }
  }

  function selectedOption(select) {
    return select.options[select.selectedIndex] || select.options[0] || null;
  }

  function updateButton(select, wrapper) {
    const buttonText = wrapper.querySelector("[data-silaba-custom-select-text]");
    if (!buttonText) return;

    const option = selectedOption(select);
    buttonText.textContent = option ? option.textContent.trim() : "";

    wrapper.querySelectorAll("[data-silaba-custom-select-option]").forEach((optionButton) => {
      const isSelected = Number(optionButton.getAttribute("data-index")) === select.selectedIndex;
      optionButton.classList.toggle("is-selected", isSelected);
      optionButton.setAttribute("aria-selected", isSelected ? "true" : "false");
    });
  }

  function closeSelect(wrapper) {
    if (!wrapper) return;

    wrapper.classList.remove("is-open", "is-dropup");
    wrapper.closest(".form__input-wrapper")?.classList.remove("is-silaba-custom-select-open");
    wrapper.closest(".modal__dialog")?.classList.remove("is-silaba-custom-select-open");
    wrapper.closest(".slb-account-profile")?.classList.remove("is-silaba-custom-select-open");
    wrapper.querySelector("[data-silaba-custom-select-button]")?.setAttribute("aria-expanded", "false");
    wrapper.style.removeProperty("--silaba-custom-select-left");
    wrapper.style.removeProperty("--silaba-custom-select-top");
    wrapper.style.removeProperty("--silaba-custom-select-width");
    wrapper.style.removeProperty("--silaba-custom-select-max-height");
  }

  function closeAll(except = null) {
    document.querySelectorAll(".silaba-custom-select.is-open").forEach((wrapper) => {
      if (wrapper !== except) closeSelect(wrapper);
    });
  }

  function openSelect(wrapper) {
    closeAll(wrapper);

    positionFloatingList(wrapper);

    wrapper.classList.add("is-open");
    wrapper.closest(".form__input-wrapper")?.classList.add("is-silaba-custom-select-open");
    wrapper.closest(".modal__dialog")?.classList.add("is-silaba-custom-select-open");
    wrapper.closest(".slb-account-profile")?.classList.add("is-silaba-custom-select-open");
    wrapper.querySelector("[data-silaba-custom-select-button]")?.setAttribute("aria-expanded", "true");

    const searchInput = wrapper.querySelector("[data-silaba-custom-select-search]");
    if (searchInput) {
      searchInput.value = "";
      filterOptions(wrapper, "");
      window.setTimeout(() => searchInput.focus(), 0);
    }
  }

  function positionFloatingList(wrapper) {
    const rect = wrapper.getBoundingClientRect();
    const viewportMargin = 16;
    const gap = 6;
    const preferredMaxHeight = 390;
    const minHeight = 180;
    const spaceBelow = window.innerHeight - rect.bottom - viewportMargin - gap;
    const spaceAbove = rect.top - viewportMargin - gap;
    const dropup = spaceBelow < 260 && spaceAbove > spaceBelow;
    const availableHeight = Math.max(minHeight, dropup ? spaceAbove : spaceBelow);
    const maxHeight = Math.min(preferredMaxHeight, availableHeight);
    const width = Math.min(Math.max(rect.width, 340), window.innerWidth - (viewportMargin * 2));
    const left = Math.min(Math.max(viewportMargin, rect.left), window.innerWidth - width - viewportMargin);
    const top = dropup
      ? Math.max(viewportMargin, rect.top - gap - maxHeight)
      : Math.min(rect.bottom + gap, window.innerHeight - viewportMargin - maxHeight);

    wrapper.classList.toggle("is-dropup", dropup);
    wrapper.style.setProperty("--silaba-custom-select-left", `${Math.round(left)}px`);
    wrapper.style.setProperty("--silaba-custom-select-top", `${Math.round(top)}px`);
    wrapper.style.setProperty("--silaba-custom-select-width", `${Math.round(width)}px`);
    wrapper.style.setProperty("--silaba-custom-select-max-height", `${Math.round(maxHeight)}px`);
  }

  function refreshOpenSelectPositions() {
    document.querySelectorAll(".silaba-custom-select.is-open").forEach(positionFloatingList);
  }

  function optionButtons(select) {
    return Array.from(select.options).map((option, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "silaba-custom-select__option";
      button.setAttribute("data-silaba-custom-select-option", "");
      button.setAttribute("data-value", option.value);
      button.setAttribute("data-index", String(index));
      button.setAttribute("role", "option");
      button.dataset.search = option.dataset.search || normalizeSearch(option.textContent);
      button.textContent = option.textContent.trim();

      if (option.disabled) {
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
      }

      return button;
    });
  }

  function filterOptions(wrapper, query) {
    const normalizedQuery = normalizeSearch(query);
    let visibleOptions = 0;

    wrapper.querySelectorAll("[data-silaba-custom-select-option]").forEach((optionButton) => {
      const isVisible = !normalizedQuery || String(optionButton.dataset.search || "").includes(normalizedQuery);
      optionButton.hidden = !isVisible;
      if (isVisible) visibleOptions += 1;
    });

    const emptyNode = wrapper.querySelector("[data-silaba-custom-select-empty]");
    if (emptyNode) emptyNode.hidden = visibleOptions > 0;
  }

  function searchPlaceholder() {
    const root = searchLocaleRoot();
    if (root === "es") return "Buscar país...";
    if (root === "en") return "Search country...";
    return "Pesquisar país...";
  }

  function noResultsText() {
    const root = searchLocaleRoot();
    if (root === "es") return "Sin resultados";
    if (root === "en") return "No results";
    return "Sem resultados";
  }

  function buildCustomSelect(select) {
    if (!(select instanceof HTMLSelectElement) || select.dataset.silabaCustomSelectReady === "1") return;

    populatePhoneCountrySelect(select);

    const field = select.closest(".form__input-wrapper");
    if (!field) return;

    select.dataset.silabaCustomSelectReady = "1";
    field.classList.add("has-silaba-custom-select");
    if (select.matches(PHONE_COUNTRY_SELECTOR)) {
      field.classList.add("has-silaba-phone-country-select");
    }

    const wrapper = document.createElement("div");
    const listId = `${select.id || "silaba-select"}-custom-list`.replace(/[^a-zA-Z0-9_-]/g, "-");
    const isSearchable = select.matches(PHONE_COUNTRY_SELECTOR);
    wrapper.className = `silaba-custom-select${isSearchable ? " silaba-custom-select--searchable" : ""}`;
    wrapper.innerHTML = `
      <button type="button" class="silaba-custom-select__button" data-silaba-custom-select-button aria-haspopup="listbox" aria-expanded="false" aria-controls="${listId}">
        <span data-silaba-custom-select-text></span>
      </button>
      <div class="silaba-custom-select__list" id="${listId}" role="listbox">
        ${isSearchable ? `<div class="silaba-custom-select__search"><input type="search" class="silaba-custom-select__search-input" data-silaba-custom-select-search autocomplete="off" spellcheck="false" placeholder="${searchPlaceholder()}"></div><div class="silaba-custom-select__empty" data-silaba-custom-select-empty hidden>${noResultsText()}</div>` : ""}
      </div>
    `;

    const list = wrapper.querySelector(".silaba-custom-select__list");
    optionButtons(select).forEach((button) => list.appendChild(button));
    field.appendChild(wrapper);
    updateButton(select, wrapper);

    wrapper.querySelector("[data-silaba-custom-select-button]").addEventListener("click", () => {
      if (wrapper.classList.contains("is-open")) {
        closeSelect(wrapper);
      } else {
        openSelect(wrapper);
      }
    });

    list.addEventListener("click", (event) => {
      const optionButton = event.target.closest("[data-silaba-custom-select-option]");
      if (!optionButton || optionButton.disabled) return;

      select.selectedIndex = Number(optionButton.getAttribute("data-index"));
      select.dispatchEvent(new Event("change", { bubbles: true }));
      select.dispatchEvent(new Event("input", { bubbles: true }));
      updateButton(select, wrapper);
      closeSelect(wrapper);
    });

    const searchInput = wrapper.querySelector("[data-silaba-custom-select-search]");
    if (searchInput) {
      searchInput.addEventListener("input", () => filterOptions(wrapper, searchInput.value));
      searchInput.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          closeSelect(wrapper);
          wrapper.querySelector("[data-silaba-custom-select-button]")?.focus();
        }
      });
    }

    wrapper.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeSelect(wrapper);
        wrapper.querySelector("[data-silaba-custom-select-button]")?.focus();
        return;
      }

      if (isSearchable && event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey && event.target !== searchInput) {
        openSelect(wrapper);
        if (searchInput) {
          searchInput.value = `${searchInput.value}${event.key}`;
          filterOptions(wrapper, searchInput.value);
          searchInput.focus();
        }
        event.preventDefault();
      }
    });

    select.addEventListener("change", () => updateButton(select, wrapper));
  }

  function init(root = document) {
    root.querySelectorAll(SELECTOR).forEach(buildCustomSelect);
  }

  document.addEventListener("click", (event) => {
    if (event.target instanceof Element && event.target.closest(".silaba-custom-select")) return;
    closeAll();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeAll();
  });

  window.addEventListener("resize", refreshOpenSelectPositions);
  document.addEventListener("scroll", refreshOpenSelectPositions, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }
})();

/* ========================================================================== */
/* SÍLABA - Account profile API form                                           */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_account_profile_api_form_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const OPEN_AFTER_LOGIN_KEY = "silaba:open-account-completion-after-login";
  const DISMISSED_AFTER_LOGIN_KEY = "silaba:account-completion-dismissed";
  const LOGIN_FORM_SELECTOR = "#customer_login, #header_customer_login";

  function locale() {
    return window.Shopify?.locale || document.documentElement.lang || navigator.language || "pt";
  }

  function localeRoot() {
    const value = String(locale() || "pt").toLowerCase();
    if (value.startsWith("es")) return "es";
    if (value.startsWith("en")) return "en";
    return "pt";
  }

  function accountText(key) {
    const dictionary = {
      pt: {
        birthDate: "Data de nascimento (opcional)",
        clientType: "Tipo de cliente",
        clientTypePlaceholder: "Selecione o tipo de cliente",
        email: "Email",
        entity: "Entidade (opcional)",
        firstName: "Nome",
        gender: "Género (opcional)",
        genderFemale: "Feminino",
        genderMale: "Masculino",
        genderOther: "Outro",
        genderPlaceholder: "Selecionar género",
        genderPreferNot: "Prefiro não responder",
        lastName: "Apelido",
        phone: "Telefone (opcional)",
        save: "Salvar",
        saving: "A salvar...",
        success: "Dados guardados com sucesso.",
        error: "Não foi possível guardar os dados. Verifique os campos e tente novamente.",
        vatNumber: "NIF"
      },
      es: {
        birthDate: "Fecha de nacimiento (opcional)",
        clientType: "Tipo de cliente",
        clientTypePlaceholder: "Selecciona el tipo de cliente",
        email: "Email",
        entity: "Entidad (opcional)",
        firstName: "Nombre",
        gender: "Género (opcional)",
        genderFemale: "Femenino",
        genderMale: "Masculino",
        genderOther: "Otro",
        genderPlaceholder: "Seleccionar género",
        genderPreferNot: "Prefiero no responder",
        lastName: "Apellido",
        phone: "Teléfono (opcional)",
        save: "Guardar",
        saving: "Guardando...",
        success: "Datos guardados correctamente.",
        error: "No se han podido guardar los datos. Revisa los campos e inténtalo de nuevo.",
        vatNumber: "NIF"
      },
      en: {
        birthDate: "Date of birth (optional)",
        clientType: "Client type",
        clientTypePlaceholder: "Select client type",
        email: "Email",
        entity: "Organization (optional)",
        firstName: "First name",
        gender: "Gender (optional)",
        genderFemale: "Female",
        genderMale: "Male",
        genderOther: "Other",
        genderPlaceholder: "Select gender",
        genderPreferNot: "Prefer not to say",
        lastName: "Last name",
        phone: "Phone (optional)",
        save: "Save",
        saving: "Saving...",
        success: "Details saved successfully.",
        error: "Could not save the details. Check the fields and try again.",
        vatNumber: "VAT number"
      }
    };

    return dictionary[localeRoot()][key] || dictionary.pt[key] || key;
  }

  function endpoint(endpointKey = "profileEndpoint", fallback = "/apps/account-api/profile", form = null) {
    const base = form?.getAttribute("data-endpoint") || window.silabaAccountApi?.[endpointKey] || fallback;
    const url = new URL(base, window.location.origin);
    url.searchParams.set("locale", locale());
    return `${url.pathname}${url.search}`;
  }

  function statusNode(form) {
    return form.querySelector("[data-slb-account-api-status]");
  }

  function setStatus(form, message, type) {
    const node = statusNode(form);
    if (!node) return;

    node.hidden = !message;
    node.textContent = message || "";
    node.classList.toggle("is-error", type === "error");
    node.classList.toggle("is-success", type === "success");
  }

  function submitButtonFor(form) {
    const localButton = form.querySelector('button[type="submit"]');
    if (localButton) return localButton;
    if (!form.id) return null;

    return Array.from(document.querySelectorAll('button[type="submit"][form]')).find((button) => button.getAttribute("form") === form.id) || null;
  }

  function phoneDigits(value) {
    return String(value || "").replace(/\D/g, "");
  }

  function payloadFromForm(form) {
    const data = new FormData(form);
    const phoneCountryCode = String(data.get("phoneCountryCode") || "").trim();
    const phoneNumber = phoneDigits(data.get("phoneNumber"));

    return {
      firstName: String(data.get("firstName") || "").trim(),
      lastName: String(data.get("lastName") || "").trim(),
      phone: phoneNumber ? `${phoneCountryCode} ${phoneNumber}`.trim() : "",
      entity: String(data.get("entity") || "").trim(),
      clientType: String(data.get("clientType") || "").trim(),
      vatNumber: String(data.get("vatNumber") || "").replace(/\D/g, ""),
      birthDate: String(data.get("birthDate") || "").trim(),
      gender: String(data.get("gender") || "").trim()
    };
  }

  function setOpenAfterLogin() {
    try {
      window.sessionStorage.setItem(OPEN_AFTER_LOGIN_KEY, "1");
      window.sessionStorage.removeItem(DISMISSED_AFTER_LOGIN_KEY);
    } catch (error) {
    }
  }

  function shouldOpenAfterLogin() {
    try {
      return window.sessionStorage.getItem(OPEN_AFTER_LOGIN_KEY) === "1" && window.sessionStorage.getItem(DISMISSED_AFTER_LOGIN_KEY) !== "1";
    } catch (error) {
      return false;
    }
  }

  function clearOpenAfterLogin() {
    try {
      window.sessionStorage.removeItem(OPEN_AFTER_LOGIN_KEY);
    } catch (error) {
    }
  }

  function dismissCompletionModal() {
    try {
      window.sessionStorage.setItem(DISMISSED_AFTER_LOGIN_KEY, "1");
      window.sessionStorage.removeItem(OPEN_AFTER_LOGIN_KEY);
    } catch (error) {
    }
  }

  function forceCloseCompletionModal() {
    const modal = document.getElementById("modal-account-completion");
    if (!modal) return;

    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("is-locked");
  }

  function isManageAccountPage() {
    return (
      document.body?.classList.contains("template-addresses") ||
      document.body?.classList.contains("template-customers-addresses") ||
      window.location.pathname.includes("/account/addresses")
    );
  }

  function errorMessage(form, payload) {
    const fallback = form.getAttribute("data-error-label") || accountText("error");
    const errors = Array.isArray(payload?.errors) ? payload.errors : [];
    if (!errors.length) {
      if (payload?.error === "request_failed" || payload?.error === "internal_error") return fallback;
      return payload?.message || fallback;
    }
    return errors.map((error) => error.message).filter(Boolean).join(" ") || fallback;
  }

  async function submitProfileForm(form) {
    if (!form.reportValidity()) return;

    const button = submitButtonFor(form);
    const originalButtonText = button ? button.textContent : "";
    const savingLabel = form.getAttribute("data-saving-label") || originalButtonText;

    setStatus(form, "", "");
    form.classList.add("is-loading");
    if (button) {
      button.disabled = true;
      button.textContent = savingLabel;
    }

    try {
      const response = await fetch(endpoint("profileEndpoint", "/apps/account-api/profile", form), {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(payloadFromForm(form))
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        setStatus(form, errorMessage(form, result), "error");
        return;
      }

      if (result?.customer) {
        window.silabaCustomer = {
          ...(window.silabaCustomer || {}),
          loggedIn: true,
          id: result.customer.numericId || window.silabaCustomer?.id || null,
          phone: result.customer.phone || null,
          vatNumber: result.customer.vatNumber || null,
          clientType: result.customer.clientType || null
        };
      }

      if (typeof window.SilabaSyncCustomerCartAttributes === "function") {
        await window.SilabaSyncCustomerCartAttributes({ force: true });
      }

      setStatus(form, form.getAttribute("data-success-label") || accountText("success"), "success");

      if (form.closest("[data-slb-account-completion-modal]")) {
        window.setTimeout(() => window.location.reload(), 700);
      }
    } catch (error) {
      setStatus(form, form.getAttribute("data-error-label") || accountText("error"), "error");
    } finally {
      form.classList.remove("is-loading");
      if (button) {
        button.disabled = false;
        button.textContent = originalButtonText;
      }
    }
  }

  async function submitPasswordForm(form) {
    if (!form.reportValidity()) return;

    const data = new FormData(form);
    const currentPassword = String(data.get("currentPassword") || "");
    const password = String(data.get("password") || "");
    const passwordConfirmation = String(data.get("passwordConfirmation") || "");

    if (password !== passwordConfirmation) {
      setStatus(form, form.getAttribute("data-mismatch-label") || accountText("error"), "error");
      return;
    }

    const button = submitButtonFor(form);
    const originalButtonText = button ? button.textContent : "";
    const savingLabel = form.getAttribute("data-saving-label") || originalButtonText;

    setStatus(form, "", "");
    form.classList.add("is-loading");
    if (button) {
      button.disabled = true;
      button.textContent = savingLabel;
    }

    try {
      const response = await fetch(endpoint("passwordEndpoint", "/apps/account-api/password", form), {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ currentPassword, password, passwordConfirmation })
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        setStatus(form, errorMessage(form, result), "error");
        return;
      }

      form.reset();
      setStatus(form, form.getAttribute("data-success-label") || accountText("success"), "success");
      window.setTimeout(() => form.closest(".modal")?.querySelector('[data-action="close-modal"]')?.click(), 900);
    } catch (error) {
      setStatus(form, form.getAttribute("data-error-label") || accountText("error"), "error");
    } finally {
      form.classList.remove("is-loading");
      if (button) {
        button.disabled = false;
        button.textContent = originalButtonText;
      }
    }
  }

  async function submitCancelAccountForm(form) {
    if (!form.reportValidity()) return;

    const button = submitButtonFor(form);
    const originalButtonText = button ? button.textContent : "";
    const savingLabel = form.getAttribute("data-saving-label") || originalButtonText;

    setStatus(form, "", "");
    form.classList.add("is-loading");
    if (button) {
      button.disabled = true;
      button.textContent = savingLabel;
    }

    try {
      const response = await fetch(endpoint("cancelAccountEndpoint", "/apps/account-api/cancel-account", form), {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ confirm: true })
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        setStatus(form, errorMessage(form, result), "error");
        return;
      }

      setStatus(form, form.getAttribute("data-success-label") || accountText("success"), "success");
      window.setTimeout(() => {
        window.location.href = form.getAttribute("data-redirect") || "/account/logout";
      }, 800);
    } catch (error) {
      setStatus(form, form.getAttribute("data-error-label") || accountText("error"), "error");
    } finally {
      form.classList.remove("is-loading");
      if (button) {
        button.disabled = false;
        button.textContent = originalButtonText;
      }
    }
  }

  function openCompletionModal() {
    if (isManageAccountPage()) {
      clearOpenAfterLogin();
      forceCloseCompletionModal();
      return;
    }

    const triggers = Array.from(document.querySelectorAll("[data-slb-auto-open-modal]"));

    if (!triggers.length) {
      if (window.silabaCustomer?.loggedIn) {
        clearOpenAfterLogin();
      }

      return;
    }

    if (!shouldOpenAfterLogin()) return;

    triggers.forEach((trigger) => {
      if (!(trigger instanceof HTMLElement) || trigger.dataset.slbOpened === "1") return;

      trigger.dataset.slbOpened = "1";
      window.setTimeout(() => trigger.click(), 180);
    });

    clearOpenAfterLogin();
  }

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches("[data-slb-account-api-form]")) return;

    event.preventDefault();
    submitProfileForm(form);
  });

  document.addEventListener("input", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches("[data-silaba-phone-number]")) return;

    const sanitized = phoneDigits(input.value);
    if (input.value !== sanitized) {
      input.value = sanitized;
    }
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches("[data-slb-account-password-form]")) return;

    event.preventDefault();
    submitPasswordForm(form);
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches("[data-slb-account-cancel-form]")) return;

    event.preventDefault();
    submitCancelAccountForm(form);
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(LOGIN_FORM_SELECTOR)) return;

    setOpenAfterLogin();
  }, true);

  document.addEventListener("click", (event) => {
    if (isManageAccountPage()) {
      const modalTrigger = event.target.closest('[aria-controls="modal-account-completion"], [aria-controls="modal-account-profile"]');

      if (modalTrigger) {
        event.preventDefault();
        event.stopPropagation();
        dismissCompletionModal();
        forceCloseCompletionModal();
        return;
      }
    }

    const closeButton = event.target.closest("[data-slb-account-completion-close]");
    if (!closeButton) return;

    dismissCompletionModal();
    window.setTimeout(forceCloseCompletionModal, 0);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      openCompletionModal();
    }, { once: true });
  } else {
    openCompletionModal();
  }
})();

/* ========================================================================== */
/* SÍLABA - Account promotions and coupon strip                                */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_account_promotions_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  function locale() {
    return window.Shopify?.locale || document.documentElement.lang || navigator.language || "pt";
  }

  function localeRoot() {
    const value = String(locale() || "pt").toLowerCase();
    if (value.startsWith("es")) return "es";
    if (value.startsWith("en")) return "en";
    return "pt";
  }

  function text(key) {
    const dictionary = {
      pt: {
        copied: "Copiado",
        copy: "Copiar",
        customer: "Disponível para si",
        empty: "Não existem cupões disponíveis neste momento.",
        error: "Não foi possível carregar os cupões.",
        loading: "A carregar cupões...",
        public: "Todos os clientes"
      },
      es: {
        copied: "Copiado",
        copy: "Copiar",
        customer: "Disponible para ti",
        empty: "No hay cupones disponibles en este momento.",
        error: "No se han podido cargar los cupones.",
        loading: "Cargando cupones...",
        public: "Todos los clientes"
      },
      en: {
        copied: "Copied",
        copy: "Copy",
        customer: "Available for you",
        empty: "There are no coupons available at the moment.",
        error: "Could not load coupons.",
        loading: "Loading coupons...",
        public: "All customers"
      }
    };

    return dictionary[localeRoot()][key] || dictionary.pt[key] || key;
  }

  function endpoint(root) {
    const base = root?.getAttribute("data-endpoint") || window.silabaAccountApi?.promotionsEndpoint || "/apps/account-api/promotions";
    const url = new URL(base, window.location.origin);
    url.searchParams.set("locale", locale());
    return `${url.pathname}${url.search}`;
  }

  function setStatus(root, message, type = "") {
    const node = root.querySelector("[data-slb-promotions-status]");
    if (!node) return;

    node.hidden = !message;
    node.textContent = message || "";
    node.classList.toggle("is-error", type === "error");
  }

  function setEmpty(root, visible, message = text("empty")) {
    const node = root.querySelector("[data-slb-promotions-empty]");
    if (!node) return;

    node.hidden = !visible;
    node.textContent = message;
  }

  function appendText(parent, className, value) {
    if (!value) return null;

    const node = document.createElement("span");
    node.className = className;
    node.textContent = value;
    parent.appendChild(node);
    return node;
  }

  function renderPromotion(promotion) {
    const item = document.createElement("article");
    item.className = `slb-coupon slb-coupon--${promotion.eligibility === "customer" ? "customer" : "public"}`;

    const content = document.createElement("div");
    content.className = "slb-coupon__content";
    item.appendChild(content);

    appendText(
      content,
      "slb-coupon__label",
      promotion.eligibilityLabel || (promotion.eligibility === "customer" ? text("customer") : text("public"))
    );

    appendText(content, "slb-coupon__title", promotion.title);
    appendText(content, "slb-coupon__value", promotion.valueLabel || promotion.summary);

    const button = document.createElement("button");
    button.type = "button";
    button.className = "slb-coupon__code";
    button.textContent = promotion.code;
    button.setAttribute("data-slb-copy-coupon", promotion.code);
    button.setAttribute("aria-label", `${text("copy")} ${promotion.code}`);
    item.appendChild(button);

    return item;
  }

  function renderPromotions(root, promotions) {
    const list = root.querySelector("[data-slb-promotions-list]");
    if (!list) return;

    list.replaceChildren();

    if (!promotions.length) {
      list.hidden = true;
      setEmpty(root, true);
      return;
    }

    const fragment = document.createDocumentFragment();
    promotions.forEach((promotion) => fragment.appendChild(renderPromotion(promotion)));
    list.appendChild(fragment);
    list.hidden = false;
    setEmpty(root, false);
  }

  async function loadPromotions(root) {
    const list = root.querySelector("[data-slb-promotions-list]");
    const hasFallbackCoupons = Boolean(list?.children.length);

    setStatus(root, text("loading"));

    try {
      const response = await fetch(endpoint(root), {
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload?.message || "promotions_failed");

      renderPromotions(root, Array.isArray(payload.promotions) ? payload.promotions : []);
      setStatus(root, "");
    } catch (error) {
      if (hasFallbackCoupons) {
        setStatus(root, "");
        setEmpty(root, false);
      } else {
        setStatus(root, text("error"), "error");
        setEmpty(root, true);
      }
    }
  }

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-slb-copy-coupon]");
    if (!button) return;

    const code = button.getAttribute("data-slb-copy-coupon") || button.textContent.trim();
    if (!code) return;

    try {
      await navigator.clipboard?.writeText(code);
      const original = button.textContent;
      button.textContent = text("copied");
      window.setTimeout(() => {
        button.textContent = original;
      }, 1200);
    } catch (error) {
    }
  });

  function init(root = document) {
    root.querySelectorAll("[data-slb-promotions]").forEach((node) => {
      if (node.dataset.slbPromotionsReady === "1") return;

      node.dataset.slbPromotionsReady = "1";
      loadPromotions(node);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }
})();

/* ========================================================================== */
/* SÍLABA - Buy now button (direct checkout without Shopify dynamic buttons)   */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_buy_now_checkout_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  function showInlineError(button, message) {
    const productForm = button.closest(".product-form") || button.closest("product-form");
    const host = button.closest(".product-form__buy-buttons") || productForm;
    if (!host) return;

    host.querySelectorAll(".cart__status-message--product").forEach((node) => node.remove());

    const wrapper = document.createElement("div");
    wrapper.className = "cart__status-message cart__status-message--product";
    wrapper.innerHTML = `<div class="alert alert--error"><p>${message}</p></div>`;
    host.appendChild(wrapper);
  }

  document.addEventListener(
    "click",
    async function (event) {
      const button = event.target.closest('buy-button[data-redirect-to-checkout="true"] button');
      if (!button) return;

      const formElement = button.closest('form[action*="/cart/add"]');
      if (!formElement || button.hasAttribute("disabled")) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      button.setAttribute("disabled", "disabled");
      document.dispatchEvent(new CustomEvent("theme:loading:start"));

      try {
        const response = await fetch(`${window.routes.cartAddUrl}.js`, {
          body: JSON.stringify(Form.serialize(formElement)),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        });

        if (response.ok) {
          if (typeof window.SilabaSyncCustomerCartAttributes === "function") {
            await window.SilabaSyncCustomerCartAttributes({ force: true });
          }

          window.location.href = `${window.routes.cartUrl}/checkout`;
          return;
        }

        const content = await response.json();
        showInlineError(button, content.description || "Error");
      } catch (error) {
        showInlineError(button, "Error");
      } finally {
        button.removeAttribute("disabled");
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
      }
    },
    true
  );
})();

//***************************** */



/* ========================================================================== */
/* SÍLABA - Variant combination fallback + price sync (Warehouse block swatches)
/* Fixes: when selection has no valid combination, price stays on previous one. */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_variant_fallback_v3__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  function normalizeEuroPriceText(text) {
    return String(text || "")
      .replace(/([+-])\s*€\s*([0-9][0-9.\s]*(?:,\d{2})?)/g, "$1$2 €")
      .replace(/€\s*([+-]?[0-9][0-9.\s]*(?:,\d{2})?)\s*EUR\b/gi, "$1 €")
      .replace(/€\s*([+-]?[0-9][0-9.\s]*(?:,\d{2})?)/g, "$1 €")
      .replace(/([+-]?[0-9][0-9.\s]*(?:,\d{2})?)\s*EUR\b/gi, "$1 €")
      .replace(/\s{2,}/g, " ")
      .trim();
  }

  function normalizeVisiblePriceElement(el) {
    if (!el || !el.isConnected || el.closest(".visually-hidden")) return;

    const hidden = el.querySelector(":scope > .visually-hidden");

    if (hidden) {
      const visibleText = Array.from(el.childNodes)
        .filter((node) => !(node.nodeType === 1 && node.classList && node.classList.contains("visually-hidden")))
        .map((node) => node.textContent || "")
        .join(" ")
        .trim();

      const normalized = normalizeEuroPriceText(visibleText);
      if (normalized && normalized !== visibleText) {
        el.innerHTML = hidden.outerHTML + normalized;
      }
      return;
    }

    const current = (el.textContent || "").trim();
    const normalized = normalizeEuroPriceText(current);
    if (normalized && normalized !== current) {
      el.textContent = normalized;
    }
  }

  function normalizeVisiblePrices(root) {
    const selector = [
      ".price",
      ".cart-recap__price-line-price",
      ".mini-cart__recap-price-line span:last-child",
      ".line-item__price",
      ".line-item__line-price",
      ".order-foot__item-value",
      ".search-bar__item-price",
      ".unit-price-measurement__price",
      "[data-slb-price-min-label]",
      "[data-slb-price-max-label]",
      ".promo-block__price--sale",
      ".promo-block__price--compare",
      ".mosaic-lookbook__price--sale",
      ".mosaic-lookbook__price--compare"
    ].join(", ");

    if (root && root.matches && root.matches(selector)) {
      normalizeVisiblePriceElement(root);
    }

    (root || document).querySelectorAll?.(selector).forEach(normalizeVisiblePriceElement);
  }

  let normalizePricesFrame = 0;
  function scheduleNormalizeVisiblePrices() {
    if (normalizePricesFrame) cancelAnimationFrame(normalizePricesFrame);
    normalizePricesFrame = requestAnimationFrame(() => {
      normalizeVisiblePrices(document);
      normalizePricesFrame = 0;
    });
  }

  function toEl(x) {
    if (!x) return null;
    if (x.target) x = x.target;
    if (x.nodeType === 3) x = x.parentElement;
    return x && x.nodeType === 1 ? x : null;
  }

  function norm(s) {
    return String(s || "").replace(/\s+/g, " ").trim();
  }

  function getRoot(el) {
    el = toEl(el);
    return (
      (el && el.closest && el.closest("product-form")) ||
      (el && el.closest && el.closest(".shopify-section")) ||
      document
    );
  }

  function getVariantForms(root) {
    const forms = Array.from(root.querySelectorAll('form[action*="/cart/add"]'));
    return forms.filter((f) => f.querySelector('select[name="id"]') && f.querySelector('.product-form__single-selector[data-option-position]'));
  }

  function parseOptionText(optEl) {
    const raw = norm(optEl && optEl.textContent);
    const priceSeparatorIndex = raw.lastIndexOf(" - ");
    const base = priceSeparatorIndex >= 0 ? raw.slice(0, priceSeparatorIndex).trim() : raw;
    const parts = base ? base.split(" / ").map(norm).filter(Boolean) : [];
    const pricePart = priceSeparatorIndex >= 0 ? raw.slice(priceSeparatorIndex + 3).trim() : "";
    const featuredMediaId = norm(optEl && optEl.getAttribute && optEl.getAttribute("data-featured-media-id"));

    return {
      id: optEl ? String(optEl.value) : "",
      parts,
      pricePart,
      featuredMediaId
    };
  }

  function buildVariants(selectEl) {
    return Array.from(selectEl.options)
      .filter((opt) => opt.value)
      .map(parseOptionText)
      .filter((v) => v.parts.length);
  }

  function optionCount(form) {
    let max = 0;
    form.querySelectorAll(".product-form__single-selector[data-option-position]").forEach((el) => {
      const p = parseInt(el.getAttribute("data-option-position") || "0", 10);
      if (p > max) max = p;
    });
    return max || 1;
  }

  function selectedByPosition(form) {
    const count = optionCount(form);
    const selected = new Array(count).fill(null);

    for (let pos = 1; pos <= count; pos++) {
      const checked = form.querySelector(`.product-form__single-selector[data-option-position="${pos}"]:checked`);
      if (checked) {
        selected[pos - 1] = norm(checked.value);
        continue;
      }
      const select = form.querySelector(`select.product-form__single-selector[data-option-position="${pos}"]`);
      if (select) {
        selected[pos - 1] = norm(select.value);
        continue;
      }
      // fallback: first enabled input for that position
      const first = form.querySelector(`.product-form__single-selector[data-option-position="${pos}"]:not([disabled])`);
      if (first) selected[pos - 1] = norm(first.value);
    }

    return selected;
  }

  function arraysEq(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) if (norm(a[i]) !== norm(b[i])) return false;
    return true;
  }

  function findExact(variants, selected) {
    return variants.find((v) => arraysEq(v.parts, selected)) || null;
  }

  function findClosest(variants, selected, changedIndex) {
    if (!variants.length) return null;

    let candidates = variants;

    // Keep the changed option if possible
    if (changedIndex != null && selected[changedIndex] != null) {
      const keep = candidates.filter((v) => v.parts[changedIndex] === selected[changedIndex]);
      if (keep.length) candidates = keep;
    }

    // Keep other selected options only if they don't eliminate all candidates
    for (let i = 0; i < selected.length; i++) {
      if (i === changedIndex) continue;
      if (!selected[i]) continue;

      const keep = candidates.filter((v) => v.parts[i] === selected[i]);
      if (keep.length) candidates = keep;
    }

    return candidates[0] || variants[0];
  }

  function updateSelectedValueLabel(form, pos, value) {
    const block = Array.from(form.querySelectorAll(".product-form__option"))
      .find((b) => b.querySelector(`.product-form__single-selector[data-option-position="${pos}"]`));
    const span = block && block.querySelector(".product-form__selected-value");
    if (span) span.textContent = value;
  }

  function clickRadioFor(form, pos, value) {
    const input = Array.from(form.querySelectorAll(`.product-form__single-selector[data-option-position="${pos}"]`))
      .find((i) => norm(i.value) === norm(value) && !i.disabled);

    if (!input) return;

    if (input.checked) {
      updateSelectedValueLabel(form, pos, value);
      return;
    }

    // Prefer clicking the label so the theme JS reacts properly
    const id = input.getAttribute("id");
    const label = id ? form.querySelector(`label[for="${(typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(id) : id}"]`) : null;
    if (label && typeof label.click === "function") {
      label.click();
    } else {
      input.checked = true;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    updateSelectedValueLabel(form, pos, value);
  }

  function labelForInput(form, input) {
    const id = input && input.getAttribute("id");
    if (!id) return null;

    return Array.from(form.querySelectorAll("label")).find((label) => label.htmlFor === id) || null;
  }

  function valueExistsForSelection(variants, selected, posIndex, value) {
    const wanted = norm(value);
    if (!wanted || !variants.length) return false;

    return variants.some((variantObj) => {
      if (norm(variantObj.parts[posIndex]) !== wanted) return false;

      for (let i = 0; i < selected.length; i++) {
        if (i === posIndex || !selected[i]) continue;
        if (norm(variantObj.parts[i]) !== norm(selected[i])) return false;
      }

      return true;
    });
  }

  function setSelectorUnavailable(form, input, unavailable) {
    const disabled = Boolean(unavailable) && !input.checked;
    input.disabled = disabled;

    if (disabled) {
      input.setAttribute("aria-disabled", "true");
    } else {
      input.removeAttribute("aria-disabled");
    }

    const wrapper = input.closest(".color-swatch, .variant-swatch, .block-swatch");
    const label = labelForInput(form, input);
    const targets = [wrapper, label].filter(Boolean);

    targets.forEach((target) => {
      target.classList.toggle("is-unavailable", disabled);
      target.toggleAttribute("data-slb-unavailable", disabled);
    });

    if (!wrapper) return;

    wrapper.classList.toggle("color-swatch--disabled", disabled && wrapper.classList.contains("color-swatch"));
    wrapper.classList.toggle("variant-swatch--disabled", disabled && wrapper.classList.contains("variant-swatch"));
    wrapper.classList.toggle("block-swatch--disabled", disabled && wrapper.classList.contains("block-swatch"));
  }

  function refreshVariantAvailability(form) {
    const sel = form.querySelector('select[name="id"]');
    if (!sel) return;

    const variants = buildVariants(sel);
    if (!variants.length) return;

    const selected = selectedByPosition(form);

    form.querySelectorAll(".product-form__single-selector[data-option-position]").forEach((selector) => {
      const pos = parseInt(selector.getAttribute("data-option-position") || "0", 10);
      if (pos <= 0) return;

      const posIndex = pos - 1;

      if (selector.tagName === "SELECT") {
        Array.from(selector.options).forEach((option) => {
          const unavailable = !valueExistsForSelection(variants, selected, posIndex, option.value);
          option.disabled = unavailable && !option.selected;
        });
        return;
      }

      const unavailable = !valueExistsForSelection(variants, selected, posIndex, selector.value);
      setSelectorUnavailable(form, selector, unavailable);
    });
  }

  function refreshAllVariantAvailability(root) {
    getVariantForms(root || document).forEach(refreshVariantAvailability);
  }

  function scheduleVariantAvailabilityRefresh(el) {
    const root = getRoot(el);
    setTimeout(() => refreshAllVariantAvailability(root), 0);
    setTimeout(() => refreshAllVariantAvailability(document), 140);
  }

  function forcePriceFromSelect(form, variantObj) {
    // If theme already updated, do nothing. But in the bug case, this forces the visible number.
    const priceList =
      form.closest("product-form")?.querySelector(".product-form__info-content .price-list") ||
      form.closest(".product-block-list__item--info")?.querySelector(".price-list") ||
      form.querySelector(".price-list");

    if (!priceList) return;

    const main = priceList.querySelector(".price:not(.price--compare)") || priceList.querySelector(".price");
    if (!main) return;

    const vh = main.querySelector(".visually-hidden");
    const vhHtml = vh ? vh.outerHTML : "";

    // Price text source: variantObj.pricePart (from option text after dash) or current option text
    let priceText = (variantObj && variantObj.pricePart) ? variantObj.pricePart : "";
    if (!priceText) {
      const sel = form.querySelector('select[name="id"]');
      const opt = sel && sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
      priceText = opt ? parseOptionText(opt).pricePart : "";
    }
    if (!priceText) return;

    main.innerHTML = vhHtml + normalizeEuroPriceText(priceText);
  }

  function dispatchVariantMediaChange(forms, variantObj) {
    if (!variantObj || !variantObj.featuredMediaId || !forms.length) return;

    const mediaId = parseInt(variantObj.featuredMediaId, 10);
    if (!mediaId) return;

    const variantId = parseInt(variantObj.id, 10);
    const variant = {
      id: Number.isNaN(variantId) ? variantObj.id : variantId,
      featured_media: { id: mediaId }
    };

    variantObj.parts.forEach((part, index) => {
      variant[`option${index + 1}`] = part;
    });

    const root = forms[0].__silabaRoot || getRoot(forms[0]);
    const eventKey = `${variant.id}:${mediaId}`;
    if (root.__silabaVariantMediaEventKey === eventKey) return;

    root.__silabaVariantMediaEventKey = eventKey;
    setTimeout(() => {
      if (root.__silabaVariantMediaEventKey === eventKey) {
        root.__silabaVariantMediaEventKey = "";
      }
    }, 120);

    forms.forEach((form) => {
      form.dispatchEvent(new CustomEvent("variant:change", {
        bubbles: true,
        detail: {
          variant,
          previousVariant: null
        }
      }));
    });
  }

  function radiosMatchVariant(form, variantObj) {
  const count = optionCount(form);
  for (let pos = 1; pos <= count; pos++) {
    const expected = norm(variantObj.parts[pos - 1]);
    if (!expected) continue;
    const checked = form.querySelector(`.product-form__single-selector[data-option-position="${pos}"]:checked`);
    if (!checked) return false;
    if (norm(checked.value) !== expected) return false;
  }
  return true;
}

function setRadiosSilent(form, variantObj) {
  const count = optionCount(form);
  for (let pos = 1; pos <= count; pos++) {
    const expected = variantObj.parts[pos - 1];
    if (expected == null) continue;

    const input = Array.from(form.querySelectorAll(`.product-form__single-selector[data-option-position="${pos}"]`))
      .find((i) => norm(i.value) === norm(expected) && !i.disabled);

    if (!input) continue;

    if (!input.checked) {
      input.checked = true;
    }
    updateSelectedValueLabel(form, pos, expected);
  }
}

function applyVariant(forms, variantObj) {
  if (!variantObj || !forms.length) return;
  const root = forms[0].__silabaRoot || getRoot(forms[0]);

  // Prevent loops during our own sync
  if (root.__silabaVariantSyncing) return;

  // If everything already matches, do nothing (avoids breaking other UI like mini-cart)
  let needsSelectChange = false;
  let needsRadioSync = false;

  for (const form of forms) {
    const sel = form.querySelector('select[name="id"]');
    if (sel && String(sel.value) !== String(variantObj.id)) needsSelectChange = true;
    if (!radiosMatchVariant(form, variantObj)) needsRadioSync = true;
  }

    if (!needsSelectChange && !needsRadioSync) {
      for (const form of forms) {
        forcePriceFromSelect(form, variantObj);
        refreshVariantAvailability(form);
      }
      dispatchVariantMediaChange(forms, variantObj);
      scheduleNormalizeVisiblePrices();
      return;
    }

  root.__silabaVariantSyncing = true;

  try {
    // 1) Sync radios silently (no label clicks) to avoid extra theme side effects
    if (needsRadioSync) {
      for (const form of forms) setRadiosSilent(form, variantObj);
    }

    // 2) Sync variant select and fire events ONLY when we actually changed the id
    if (needsSelectChange) {
      for (const form of forms) {
        const sel = form.querySelector('select[name="id"]');
        if (!sel) continue;

        sel.value = variantObj.id;

        // Some themes listen to input, some to change; fire both.
        sel.dispatchEvent(new Event("input", { bubbles: true }));
        sel.dispatchEvent(new Event("change", { bubbles: true }));

        // Force price display as last resort (bug case)
        forcePriceFromSelect(form, variantObj);
      }
    }

    if (!needsSelectChange || needsRadioSync) {
      for (const form of forms) {
        forcePriceFromSelect(form, variantObj);
      }
    }

    scheduleNormalizeVisiblePrices();
    forms.forEach(refreshVariantAvailability);
    dispatchVariantMediaChange(forms, variantObj);
  } finally {
    setTimeout(() => { root.__silabaVariantSyncing = false; }, 0);
  }
}


  function handleChange(el) {
    el = toEl(el);
    if (!el) return;

    const root = getRoot(el);
    const forms = getVariantForms(root);
    if (!forms.length) return;

    // cache root on forms
    forms.forEach(f => (f.__silabaRoot = root));

    const form = el.closest('form[action*="/cart/add"]') || forms[0];
    const sel = form.querySelector('select[name="id"]');
    if (!sel) return;

    const variants = buildVariants(sel);
    const selected = selectedByPosition(form);

    // changed option index
    let changedIndex = null;
    if (el.classList && el.classList.contains("product-form__single-selector")) {
      const pos = parseInt(el.getAttribute("data-option-position") || "0", 10);
      if (pos > 0) changedIndex = pos - 1;
    } else {
      // label click
      const forId = el.getAttribute && el.getAttribute("for");
      if (forId) {
        const inp = root.querySelector("#" + forId);
        if (inp) {
          const pos = parseInt(inp.getAttribute("data-option-position") || "0", 10);
          if (pos > 0) changedIndex = pos - 1;
        }
      }
    }

    const exact = findExact(variants, selected);
    if (exact) {
      applyVariant(forms, exact);
      return;
    }

    const closest = findClosest(variants, selected, changedIndex);
    if (closest) {
      applyVariant(forms, closest);
    } else {
      forms.forEach(refreshVariantAvailability);
    }
  }

  // Listen to radio/select changes
  document.addEventListener(
    "change",
    function (e) {
      const t = toEl(e);
      if (!t) return;

      if (t.matches && (t.matches('.product-form__single-selector[type="radio"]') || t.matches('select.product-form__single-selector[data-option-position]') || t.matches('select[name="id"]'))) {
        setTimeout(() => handleChange(t), 0);
        setTimeout(() => handleChange(t), 60);
      }
    },
    true
  );

  document.addEventListener("variant:change", (event) => scheduleVariantAvailabilityRefresh(event.target), true);
  document.addEventListener("variant:changed", (event) => scheduleVariantAvailabilityRefresh(event.target), true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      normalizeVisiblePrices(document);
      refreshAllVariantAvailability(document);
    }, { once: true });
  } else {
    normalizeVisiblePrices(document);
    refreshAllVariantAvailability(document);
  }

  const priceObserver = new MutationObserver(() => {
    scheduleNormalizeVisiblePrices();
  });

  priceObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  document.addEventListener("shopify:section:load", (event) => {
    scheduleNormalizeVisiblePrices();
    setTimeout(() => refreshAllVariantAvailability(event.target || document), 0);
  }, true);
  document.addEventListener("shopify:section:reorder", (event) => {
    scheduleNormalizeVisiblePrices();
    setTimeout(() => refreshAllVariantAvailability(event.target || document), 0);
  }, true);
})();

/* ========================================================================== */
/* SÍLABA - Product variant SKU + price display sync                          */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_product_variant_display_sync_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  function norm(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function normalizeEuroPriceText(text) {
    return String(text || "")
      .replace(/([+-])\s*€\s*([0-9][0-9.\s]*(?:,\d{2})?)/g, "$1$2 €")
      .replace(/€\s*([+-]?[0-9][0-9.\s]*(?:,\d{2})?)\s*EUR\b/gi, "$1 €")
      .replace(/€\s*([+-]?[0-9][0-9.\s]*(?:,\d{2})?)/g, "$1 €")
      .replace(/([+-]?[0-9][0-9.\s]*(?:,\d{2})?)\s*EUR\b/gi, "$1 €")
      .replace(/\s{2,}/g, " ")
      .trim();
  }

  function toCents(value) {
    const number = parseInt(String(value || "").replace(/[^\d-]/g, ""), 10);
    return Number.isFinite(number) ? number : 0;
  }

  function centsFromPriceText(text) {
    const normalized = String(text || "").replace(/\s+/g, " ").trim();
    const match = normalized.match(/([0-9][0-9.\s]*(?:,\d{1,2})?)/);
    if (!match) return 0;

    const amount = match[1].replace(/\./g, "").replace(/\s/g, "").replace(",", ".");
    const number = Number.parseFloat(amount);
    return Number.isFinite(number) ? Math.round(number * 100) : 0;
  }

  function formatMoneyCents(cents) {
    const value = (toCents(cents) / 100).toFixed(2).replace(".", ",");
    return `${value} €`;
  }

  function parseOption(option) {
    const raw = norm(option && option.textContent);
    const priceSeparatorIndex = raw.lastIndexOf(" - ");
    const title = priceSeparatorIndex >= 0 ? raw.slice(0, priceSeparatorIndex).trim() : raw;
    const priceFromText = priceSeparatorIndex >= 0 ? raw.slice(priceSeparatorIndex + 3).trim() : "";

    return {
      option,
      id: option ? String(option.value) : "",
      sku: option ? norm(option.getAttribute("data-sku")) : "",
      priceCents: option ? toCents(option.getAttribute("data-price-cents")) : 0,
      comparePriceCents: option ? toCents(option.getAttribute("data-compare-price-cents")) : 0,
      priceText: option ? norm(option.getAttribute("data-price")) || priceFromText : "",
      comparePriceText: option ? norm(option.getAttribute("data-compare-price")) : "",
      parts: title ? title.split(" / ").map(norm).filter(Boolean) : []
    };
  }

  function optionCount(form) {
    let count = 0;
    form.querySelectorAll(".product-form__single-selector[data-option-position]").forEach((input) => {
      count = Math.max(count, parseInt(input.getAttribute("data-option-position") || "0", 10));
    });

    return count || 1;
  }

  function selectedParts(form) {
    const count = optionCount(form);
    const selected = new Array(count).fill("");

    for (let pos = 1; pos <= count; pos++) {
      const checked = form.querySelector(`.product-form__single-selector[data-option-position="${pos}"]:checked`);
      const select = form.querySelector(`select.product-form__single-selector[data-option-position="${pos}"]`);
      const input = checked || select;

      if (input) selected[pos - 1] = norm(input.value);
    }

    return selected;
  }

  function partsMatch(optionParts, selected) {
    if (!optionParts.length || optionParts.length !== selected.length) return false;

    for (let i = 0; i < selected.length; i++) {
      if (norm(optionParts[i]) !== norm(selected[i])) return false;
    }

    return true;
  }

  function selectedVariantOption(form) {
    const select = form.querySelector('select[name="id"]');
    if (!select) {
      const input = form.querySelector('input[name="id"]');
      return input ? {
        option: input,
        id: String(input.value || ""),
        sku: norm(input.getAttribute("data-sku")),
        priceCents: toCents(input.getAttribute("data-price-cents")),
        comparePriceCents: toCents(input.getAttribute("data-compare-price-cents")),
        priceText: "",
        comparePriceText: "",
        parts: []
      } : null;
    }

    const selected = selectedParts(form);
    const matchingOption = Array.from(select.options)
      .map(parseOption)
      .find((variant) => partsMatch(variant.parts, selected));

    if (matchingOption) {
      if (String(select.value) !== matchingOption.id) {
        select.value = matchingOption.id;
      }

      return matchingOption;
    }

    const selectedOption = select.options[select.selectedIndex] || select.querySelector("option");
    return selectedOption ? parseOption(selectedOption) : null;
  }

  function formScope(form) {
    return form.closest("product-form") || form.closest(".product-block-list__item--info") || form;
  }

  function updateSku(form, variant) {
    const scope = formScope(form);
    const skuWrapper = scope.querySelector(".product-meta__sku");
    const skuNumber = scope.querySelector(".product-meta__sku-number");

    if (!skuWrapper || !skuNumber) return;

    skuNumber.textContent = variant.sku;
    skuWrapper.style.display = variant.sku ? "" : "none";
  }

  function existingHiddenText(priceList, selector, fallback) {
    return norm(priceList.querySelector(`${selector} .visually-hidden`)?.textContent) || fallback;
  }

  function makePriceNode(className, hiddenText, priceText, unitPriceCents) {
    const price = document.createElement("span");
    const hidden = document.createElement("span");

    price.className = className;
    if (unitPriceCents) {
      price.setAttribute("data-slb-unit-price-cents", String(unitPriceCents));
    }
    hidden.className = "visually-hidden";
    hidden.textContent = hiddenText;

    price.appendChild(hidden);
    price.appendChild(document.createTextNode(normalizeEuroPriceText(priceText)));

    return price;
  }

  function quantityMultiplier(form, priceList) {
    const minQty = parseInt(priceList?.getAttribute("data-slb-min-qty") || "1", 10) || 1;
    const input = form.querySelector('input[name="quantity"]');
    const quantity = parseInt(input?.value || input?.getAttribute("value") || `${minQty}`, 10);
    const fallbackQuantity = Math.max(1, minQty);

    return Math.max(fallbackQuantity, Number.isFinite(quantity) ? quantity : fallbackQuantity);
  }

  function updatePrice(form, variant) {
    const scope = formScope(form);
    const priceList = scope.querySelector(".product-form__info-item:first-child .price-list") || scope.querySelector(".price-list");
    if (!priceList) return;
    if (priceList.querySelector(".price--on-request")) return;

    const multiplier = quantityMultiplier(form, priceList);
    const priceCents = variant.priceCents || centsFromPriceText(variant.priceText);
    const comparePriceCents = variant.comparePriceCents || centsFromPriceText(variant.comparePriceText);
    if (!priceCents && !variant.priceText) return;

    const saleHiddenText = existingHiddenText(priceList, ".price:not(.price--compare)", "Preço promocional");
    const regularHiddenText = existingHiddenText(priceList, ".price--compare", "Preço normal");
    const normalizedPrice = priceCents ? formatMoneyCents(priceCents * multiplier) : normalizeEuroPriceText(variant.priceText);
    const normalizedComparePrice = comparePriceCents ? formatMoneyCents(comparePriceCents * multiplier) : normalizeEuroPriceText(variant.comparePriceText);

    if (normalizedComparePrice) {
      priceList.replaceChildren(
        makePriceNode("price price--highlight", saleHiddenText, normalizedPrice, priceCents),
        makePriceNode("price price--compare", regularHiddenText, normalizedComparePrice, comparePriceCents)
      );
    } else {
      priceList.replaceChildren(makePriceNode("price", saleHiddenText, normalizedPrice, priceCents));
    }
  }

  function syncForm(form) {
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    const variant = selectedVariantOption(form);
    if (!variant) return;

    updateSku(form, variant);
    updatePrice(form, variant);
  }

  function scheduleSync(target) {
    const form = target && target.closest ? target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;

    window.setTimeout(() => syncForm(form), 0);
    window.setTimeout(() => syncForm(form), 80);
    window.setTimeout(() => syncForm(form), 220);
  }

  document.addEventListener("change", function (event) {
    const target = event.target;
    if (!target || !target.matches) return;

    if (
      target.matches(".product-form__single-selector[data-option-position]") ||
      target.matches('select[name="id"]') ||
      target.matches('input[name="quantity"]')
    ) {
      scheduleSync(target);
    }
  }, true);

  document.addEventListener("input", function (event) {
    const target = event.target;
    if (!target || !target.matches || !target.matches('input[name="quantity"]')) return;

    scheduleSync(target);
  }, true);

  document.addEventListener("click", function (event) {
    const label = event.target && event.target.closest
      ? event.target.closest(".variant-swatch__item, .color-swatch__item, .block-swatch__item")
      : null;

    if (label) scheduleSync(label);
  }, true);

  function syncAll() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(syncForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAll, { once: true });
  } else {
    syncAll();
  }

  document.addEventListener("shopify:section:load", syncAll, true);
})();

/* ========================================================================== */
/* SÍLABA - Product gallery click zoom (desktop/tablet)                         */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_product_gallery_click_zoom_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const STYLE_ID = "silaba-product-gallery-click-zoom-style";
  const OVERLAY_ID = "silaba-product-gallery-click-zoom";

  let galleryItems = [];
  let currentIndex = 0;
  let activePointerTap = null;
  let activeTouchTap = null;
  let suppressClickUntil = 0;
  const TAP_MOVE_TOLERANCE = 12;

  function isDesktopZoomViewport() {
    return window.matchMedia && window.matchMedia("(min-width: 641px)").matches;
  }

  function closestTarget(target, selector) {
    if (!target) return null;
    if (target.nodeType === 3) target = target.parentElement;
    return target && target.closest ? target.closest(selector) : null;
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .drift-zoom-pane,
      .drift-bounding-box,
      .product__zoom-wrapper {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      .product-gallery .product-gallery__thumbnail,
      .product-gallery .product-gallery__thumbnail img,
      .product-gallery .product-gallery__thumbnail .aspect-ratio {
        border-radius: 0 !important;
      }

      #${OVERLAY_ID} {
        position: fixed;
        inset: 0;
        z-index: 999999;
        display: none;
        grid-template-columns: 174px minmax(0, 1fr);
        gap: 30px;
        align-items: stretch;
        padding: 28px 64px 28px 34px;
        background: rgba(18, 18, 18, 0.88);
      }

      #${OVERLAY_ID}.is-open {
        display: grid;
      }

      #${OVERLAY_ID} .silaba-zoom__thumbs {
        display: grid;
        grid-template-columns: repeat(2, 76px);
        align-content: start;
        gap: 14px;
        max-height: calc(100vh - 56px);
        overflow-y: auto;
        padding-right: 4px;
      }

      #${OVERLAY_ID} .silaba-zoom__thumb {
        display: block;
        width: 76px;
        height: 76px;
        padding: 0;
        border: 1px solid transparent;
        border-radius: 0 !important;
        background: #fff;
        cursor: pointer;
        overflow: hidden;
        -webkit-appearance: none;
        appearance: none;
      }

      #${OVERLAY_ID} .silaba-zoom__thumb *,
      #${OVERLAY_ID} .silaba-zoom__thumb::before,
      #${OVERLAY_ID} .silaba-zoom__thumb::after {
        border-radius: 0 !important;
      }

      #${OVERLAY_ID} .silaba-zoom__thumb.is-selected {
        border-color: #f2552c;
      }

      #${OVERLAY_ID} .silaba-zoom__thumb img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 0 !important;
      }

      #${OVERLAY_ID} .silaba-zoom__stage {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 0;
        min-height: 0;
        height: calc(100vh - 56px);
      }

      #${OVERLAY_ID} .silaba-zoom__image {
        display: block;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 0 !important;
      }

      #${OVERLAY_ID} .silaba-zoom__button {
        position: absolute;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border: 0;
        border-radius: 8px;
        background: #fff;
        color: #111;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;
        box-shadow: 0 8px 22px rgba(0, 0, 0, 0.24);
      }

      #${OVERLAY_ID} .silaba-zoom__close {
        top: 22px;
        right: 22px;
      }

      #${OVERLAY_ID} .silaba-zoom__prev {
        left: 22px;
        top: 50%;
        transform: translateY(-50%);
      }

      #${OVERLAY_ID} .silaba-zoom__next {
        right: 22px;
        top: 50%;
        transform: translateY(-50%);
      }

      #${OVERLAY_ID} .silaba-zoom__button[hidden] {
        display: none;
      }

      body.silaba-zoom-open {
        overflow: hidden;
      }

      @media (max-width: 999px) {
        #${OVERLAY_ID} {
          grid-template-columns: 92px minmax(0, 1fr);
          gap: 18px;
          padding: 22px 54px 22px 18px;
        }

        #${OVERLAY_ID} .silaba-zoom__thumbs {
          grid-template-columns: 76px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function ensureOverlay() {
    ensureStyles();

    let overlay = document.getElementById(OVERLAY_ID);
    if (overlay) return overlay;

    overlay = document.createElement("div");
    overlay.id = OVERLAY_ID;
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Imagem do produto ampliada");
    overlay.innerHTML = `
      <button type="button" class="silaba-zoom__button silaba-zoom__close" aria-label="Fechar">&times;</button>
      <button type="button" class="silaba-zoom__button silaba-zoom__prev" aria-label="Imagem anterior">&#8249;</button>
      <div class="silaba-zoom__thumbs" role="list"></div>
      <div class="silaba-zoom__stage">
        <img class="silaba-zoom__image" alt="">
      </div>
      <button type="button" class="silaba-zoom__button silaba-zoom__next" aria-label="Imagem seguinte">&#8250;</button>
    `;
    document.body.appendChild(overlay);

    overlay.addEventListener("click", function (event) {
      if (
        event.target === overlay ||
        closestTarget(event.target, ".silaba-zoom__close")
      ) {
        closeZoom();
        return;
      }

      if (closestTarget(event.target, ".silaba-zoom__prev")) {
        showImage(currentIndex - 1);
        return;
      }

      if (closestTarget(event.target, ".silaba-zoom__next")) {
        showImage(currentIndex + 1);
        return;
      }

      const thumb = closestTarget(event.target, ".silaba-zoom__thumb");
      if (thumb) {
        const index = parseInt(thumb.getAttribute("data-index") || "0", 10);
        showImage(index);
      }
    });

    return overlay;
  }

  function imageUrlFor(image) {
    return (
      image.getAttribute("data-zoom") ||
      image.currentSrc ||
      image.getAttribute("src") ||
      ""
    );
  }

  function collectItems(gallery, clickedImage) {
    const slides = Array.from(gallery.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)[data-media-type="image"]'));
    const items = slides
      .map((slide) => {
        const image = slide.querySelector(".product-gallery__image");
        return image ? {
          image,
          src: imageUrlFor(image),
          thumbSrc: image.currentSrc || image.getAttribute("src") || imageUrlFor(image),
          alt: image.getAttribute("alt") || ""
        } : null;
      })
      .filter((item) => item && item.src);

    const clickedIndex = items.findIndex((item) => item.image === clickedImage);
    const selectedIndex = items.findIndex((item) => item.image.closest(".product-gallery__carousel-item")?.classList.contains("is-selected"));

    galleryItems = items;
    currentIndex = clickedIndex >= 0 ? clickedIndex : Math.max(selectedIndex, 0);
  }

  function renderThumbs(overlay) {
    const thumbs = overlay.querySelector(".silaba-zoom__thumbs");
    thumbs.textContent = "";

    galleryItems.forEach((item, index) => {
      const button = document.createElement("button");
      const image = document.createElement("img");

      button.type = "button";
      button.className = "silaba-zoom__thumb";
      button.setAttribute("data-index", String(index));
      button.setAttribute("aria-label", `Ver imagem ${index + 1}`);
      button.setAttribute("role", "listitem");

      image.src = item.thumbSrc;
      image.alt = "";

      button.appendChild(image);
      thumbs.appendChild(button);
    });
  }

  function showImage(index) {
    if (!galleryItems.length) return;

    currentIndex = (index + galleryItems.length) % galleryItems.length;

    const overlay = ensureOverlay();
    const image = overlay.querySelector(".silaba-zoom__image");
    const item = galleryItems[currentIndex];

    image.src = item.src;
    image.alt = item.alt;

    overlay.querySelector(".silaba-zoom__prev").hidden = galleryItems.length < 2;
    overlay.querySelector(".silaba-zoom__next").hidden = galleryItems.length < 2;
    overlay.querySelectorAll(".silaba-zoom__thumb").forEach((thumb, thumbIndex) => {
      const isSelected = thumbIndex === currentIndex;
      thumb.classList.toggle("is-selected", isSelected);
      thumb.setAttribute("aria-current", isSelected ? "true" : "false");
    });
  }

  function openZoom(gallery, clickedImage) {
    collectItems(gallery, clickedImage);
    if (!galleryItems.length) return;

    const overlay = ensureOverlay();
    renderThumbs(overlay);
    showImage(currentIndex);

    overlay.classList.add("is-open");
    document.body.classList.add("silaba-zoom-open");
    overlay.querySelector(".silaba-zoom__close").focus({ preventScroll: true });
  }

  function openZoomFromEvent(event, image) {
    if (!image || !isDesktopZoomViewport()) return false;

    const gallery = image.closest(".product-gallery");
    const slide = image.closest(".product-gallery__carousel-item");
    if (!gallery || !slide || slide.classList.contains("is-filtered") || slide.getAttribute("data-media-type") !== "image") {
      return false;
    }

    event.preventDefault();
    event.stopPropagation();

    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }

    openZoom(gallery, image);
    return true;
  }

  function closeZoom() {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    overlay.classList.remove("is-open");
    document.body.classList.remove("silaba-zoom-open");
    overlay.querySelector(".silaba-zoom__image").removeAttribute("src");
  }

  document.addEventListener("click", function (event) {
    if (Date.now() < suppressClickUntil) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const image = closestTarget(event.target, ".product-gallery__image");
    openZoomFromEvent(event, image);
  }, true);

  document.addEventListener("pointerdown", function (event) {
    const image = closestTarget(event.target, ".product-gallery__image");
    if (!image || !isDesktopZoomViewport() || event.pointerType === "mouse" || event.button > 0) return;

    activePointerTap = {
      pointerId: event.pointerId,
      image,
      x: event.clientX,
      y: event.clientY,
      moved: false
    };
  }, true);

  document.addEventListener("pointermove", function (event) {
    if (!activePointerTap || activePointerTap.pointerId !== event.pointerId) return;

    const deltaX = event.clientX - activePointerTap.x;
    const deltaY = event.clientY - activePointerTap.y;
    if (Math.hypot(deltaX, deltaY) > TAP_MOVE_TOLERANCE) {
      activePointerTap.moved = true;
    }
  }, true);

  document.addEventListener("pointercancel", function (event) {
    if (activePointerTap && activePointerTap.pointerId === event.pointerId) {
      activePointerTap = null;
    }
  }, true);

  document.addEventListener("pointerup", function (event) {
    if (!activePointerTap || activePointerTap.pointerId !== event.pointerId) return;

    const tap = activePointerTap;
    activePointerTap = null;
    if (tap.moved) return;

    if (openZoomFromEvent(event, tap.image)) {
      suppressClickUntil = Date.now() + 700;
    }
  }, true);

  if (!window.PointerEvent) {
    document.addEventListener("touchstart", function (event) {
      if (event.touches.length !== 1) return;

      const image = closestTarget(event.target, ".product-gallery__image");
      if (!image || !isDesktopZoomViewport()) return;

      const touch = event.touches[0];
      activeTouchTap = {
        image,
        x: touch.clientX,
        y: touch.clientY,
        moved: false
      };
    }, true);

    document.addEventListener("touchmove", function (event) {
      if (!activeTouchTap || event.touches.length !== 1) return;

      const touch = event.touches[0];
      const deltaX = touch.clientX - activeTouchTap.x;
      const deltaY = touch.clientY - activeTouchTap.y;
      if (Math.hypot(deltaX, deltaY) > TAP_MOVE_TOLERANCE) {
        activeTouchTap.moved = true;
      }
    }, true);

    document.addEventListener("touchcancel", function () {
      activeTouchTap = null;
    }, true);

    document.addEventListener("touchend", function (event) {
      if (!activeTouchTap) return;

      const tap = activeTouchTap;
      activeTouchTap = null;
      if (tap.moved) return;

      if (openZoomFromEvent(event, tap.image)) {
        suppressClickUntil = Date.now() + 700;
      }
    }, true);
  }

  document.addEventListener("keydown", function (event) {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay || !overlay.classList.contains("is-open")) return;

    if (event.key === "Escape") {
      closeZoom();
    } else if (event.key === "ArrowLeft") {
      showImage(currentIndex - 1);
    } else if (event.key === "ArrowRight") {
      showImage(currentIndex + 1);
    }
  });

  window.addEventListener("resize", function () {
    if (!isDesktopZoomViewport()) {
      closeZoom();
    }
  }, { passive: true });

  [
    "mouseenter",
    "mouseover",
    "mousemove",
    "pointerenter",
    "pointermove"
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (closestTarget(event.target, ".product-gallery__image")) {
        event.stopImmediatePropagation();
      }
    }, true);
  });

  ensureStyles();
})();

/* ========================================================================== */
/* SÍLABA - Cart recently viewed button text fit                              */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_cart_recently_viewed_button_fit_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const SELECTOR = ".template-cart section[data-section-type='recently-viewed-products'] .recently-viewed-products-placeholder .product-item__action-button.button--primary";
  const MIN_FONT_SIZE = 10;
  const MAX_FONT_SIZE = 15;
  const SAFETY_GAP = 2;

  let canvasContext = null;
  let scheduled = false;

  function getCanvasContext() {
    if (!canvasContext) {
      canvasContext = document.createElement("canvas").getContext("2d");
    }

    return canvasContext;
  }

  function textWidth(button, fontSize) {
    const context = getCanvasContext();
    const styles = window.getComputedStyle(button);
    const text = button.textContent.replace(/\s+/g, " ").trim();

    context.font = [
      styles.fontStyle,
      styles.fontVariant,
      styles.fontWeight,
      `${fontSize}px`,
      styles.fontFamily
    ].join(" ");

    return context.measureText(text).width;
  }

  function fitButton(button) {
    if (!button || button.offsetParent === null) return;

    const styles = window.getComputedStyle(button);
    const horizontalPadding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
    const availableWidth = button.clientWidth - horizontalPadding - SAFETY_GAP;

    if (availableWidth <= 0) return;

    const requiredWidth = textWidth(button, MAX_FONT_SIZE);
    const nextFontSize = requiredWidth > availableWidth
      ? Math.max(MIN_FONT_SIZE, Math.floor((MAX_FONT_SIZE * availableWidth / requiredWidth) * 100) / 100)
      : MAX_FONT_SIZE;

    const nextValue = `${nextFontSize}px`;
    if (button.style.getPropertyValue("--silaba-cart-rv-button-font-size") !== nextValue) {
      button.style.setProperty("--silaba-cart-rv-button-font-size", nextValue);
    }
  }

  function fitButtons() {
    scheduled = false;
    document.querySelectorAll(SELECTOR).forEach(fitButton);
  }

  function scheduleFitButtons() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(fitButtons);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleFitButtons, { once: true });
  } else {
    scheduleFitButtons();
  }

  window.addEventListener("resize", scheduleFitButtons, { passive: true });
  document.addEventListener("shopify:section:load", scheduleFitButtons, true);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleFitButtons).catch(function () {});
  }

  const observer = new MutationObserver(scheduleFitButtons);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style"]
  });
})();

/* ========================================================================== */
/* SÍLABA - Cart line price formatting                                         */
/* ========================================================================== */
(function () {
  const GUARD = "__silaba_cart_line_price_format_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const PRICE_CELL_SELECTOR = ".template-cart .cart-items-card .line-item__line-price";
  const DEFAULT_TAX_LABEL = "IVA Incl.";
  let scheduled = false;

  function cleanPriceText(text) {
    return text
      .replace(/\s+/g, " ")
      .replace(/\s*IVA\s*inc(?:l)?\.?\s*$/i, "")
      .trim();
  }

  function appendTaxLabel(cell, text) {
    const label = document.createElement("span");
    label.className = "cart-tax-label";
    label.textContent = text || DEFAULT_TAX_LABEL;
    cell.appendChild(label);
  }

  function formatPriceCell(cell) {
    if (!cell) return;

    const existingPrice = cell.querySelector(".line-item__line-price-value");
    const existingTaxLabel = cell.querySelector(".cart-tax-label");
    const taxLabelText = existingTaxLabel && existingTaxLabel.textContent.trim()
      ? existingTaxLabel.textContent.trim()
      : DEFAULT_TAX_LABEL;

    cell.querySelectorAll(".cart-tax-label").forEach((label) => label.remove());

    if (existingPrice) {
      existingPrice.textContent = cleanPriceText(existingPrice.textContent) || existingPrice.textContent.trim();
      appendTaxLabel(cell, taxLabelText);
      return;
    }

    const priceText = cleanPriceText(cell.textContent);
    if (!priceText) return;

    cell.textContent = "";

    const price = document.createElement("span");
    price.className = "line-item__line-price-value";
    price.textContent = priceText;

    cell.appendChild(price);
    appendTaxLabel(cell, taxLabelText);
  }

  function formatLinePrices() {
    scheduled = false;
    document.querySelectorAll(PRICE_CELL_SELECTOR).forEach(formatPriceCell);
  }

  function scheduleFormatLinePrices() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(formatLinePrices);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleFormatLinePrices, { once: true });
  } else {
    scheduleFormatLinePrices();
  }

  document.addEventListener("cart:rerendered", scheduleFormatLinePrices);
  document.addEventListener("shopify:section:load", scheduleFormatLinePrices, true);

  const observer = new MutationObserver(scheduleFormatLinePrices);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();

(() => {
  const GUARD = "__silaba_header_menu_hover_delay_v2__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const OPEN_DELAY = 340;
  const CLOSE_DELAY = 110;
  const HEADER_SELECTOR = '[data-section-type="header"]';
  const ITEM_SELECTOR = ".nav-bar__item, .nav-dropdown__item";
  const HOVER_MEDIA_QUERY = "(hover: hover) and (pointer: fine)";
  const OPEN_BODY_CLASS = "silaba-header-menu-open";
  const OVERLAY_CLASS = "silaba-header-menu-overlay";
  const boundNavs = new Set();
  let overlayElement = null;

  function getOverlayElement() {
    if (overlayElement && overlayElement.isConnected) return overlayElement;

    overlayElement = document.querySelector(`.${OVERLAY_CLASS}`);

    if (!overlayElement) {
      overlayElement = document.createElement("div");
      overlayElement.className = OVERLAY_CLASS;
      document.body.appendChild(overlayElement);
    }

    return overlayElement;
  }

  function supportsDesktopHover() {
    return typeof window.matchMedia === "function" && window.matchMedia(HOVER_MEDIA_QUERY).matches;
  }

  function getChildren(element) {
    return Array.prototype.slice.call(element && element.children ? element.children : []);
  }

  function getDirectTrigger(item) {
    return getChildren(item).find((child) => {
      return child.matches && child.matches('[data-type="menuitem"][aria-haspopup="true"]');
    }) || null;
  }

  function getDirectMenu(item) {
    return getChildren(item).find((child) => {
      return child.matches && child.matches('[data-type="menu"][aria-hidden]');
    }) || null;
  }

  function getChildItems(menu) {
    return getChildren(menu).filter((child) => {
      return child.matches && child.matches(ITEM_SELECTOR);
    });
  }

  function clearTimer(item, key) {
    if (!item || !item[key]) return;
    clearTimeout(item[key]);
    item[key] = 0;
  }

  function clearTimers(item) {
    clearTimer(item, "__silabaHoverOpenTimer");
    clearTimer(item, "__silabaHoverCloseTimer");
  }

  function blockNativeHoverEvent(event) {
    const target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
    if (!target || !target.closest) return;

    const isNavigationHover = target.closest('[data-type="menuitem"][aria-haspopup="true"], [data-type="menu"][aria-hidden], .is-dropdown-open');
    if (!isNavigationHover) return;

    event.stopPropagation();
  }

  function bindNativeHoverBlocker(navRoot) {
    if (!navRoot || navRoot.dataset.silabaNativeHoverBlocked === "1") return;

    navRoot.dataset.silabaNativeHoverBlocked = "1";
    navRoot.addEventListener("mouseover", blockNativeHoverEvent, true);
    navRoot.addEventListener("mouseout", blockNativeHoverEvent, true);
  }

  function getOpenMenuBottom(section) {
    if (!section) return 0;

    let bottom = Math.max(section.getBoundingClientRect().bottom, 0);

    section.querySelectorAll('.nav-bar [data-type="menu"][aria-hidden="false"]').forEach((menu) => {
      bottom = Math.max(bottom, menu.getBoundingClientRect().bottom);
    });

    return Math.max(Math.round(bottom), 0);
  }

  function syncOpenMenuOverlay() {
    const overlay = getOverlayElement();
    let hasOpenMenu = false;
    let overlayTop = 0;

    document.querySelectorAll(HEADER_SELECTOR).forEach((section) => {
      const hasVisiblePanel = section.querySelector('.nav-bar [data-type="menu"][aria-hidden="false"]');
      if (!hasVisiblePanel) return;

      hasOpenMenu = true;
      overlayTop = Math.max(overlayTop, getOpenMenuBottom(section));
    });

    overlay.style.top = `${overlayTop}px`;
    document.body.classList.toggle(OPEN_BODY_CLASS, hasOpenMenu);
  }

  function syncGluedState(menu) {
    if (!menu || !menu.classList) return;

    const hasOpenChildren = getChildItems(menu).some((child) => child.classList.contains("is-dropdown-open"));
    menu.classList.toggle("nav-dropdown--glued", hasOpenChildren);
  }

  function updateInverseDirection(menu) {
    if (!menu || !menu.classList || !menu.classList.contains("nav-dropdown")) return;

    menu.classList.remove("nav-dropdown--inverse");

    const nestedMenus = menu.querySelectorAll(".nav-dropdown");
    for (let index = 0; index < nestedMenus.length; index += 1) {
      if (nestedMenus[index].getBoundingClientRect().right > window.innerWidth) {
        menu.classList.add("nav-dropdown--inverse");
        break;
      }
    }
  }

  function closeItem(item, recursive) {
    const trigger = getDirectTrigger(item);
    const menu = getDirectMenu(item);
    if (!trigger || !menu) return;

    clearTimers(item);

    if (recursive) {
      getChildItems(menu).forEach((childItem) => {
        closeItem(childItem, true);
      });
    }

    item.classList.remove("is-dropdown-open");
    trigger.setAttribute("aria-expanded", "false");
    menu.setAttribute("aria-hidden", "true");
    menu.classList.remove("nav-dropdown--inverse");

    syncGluedState(item.closest('[data-type="menu"]'));
    syncOpenMenuOverlay();
  }

  function closeSiblingItems(item) {
    const parentMenu = item.closest('[data-type="menu"]');
    if (!parentMenu) return;

    getChildItems(parentMenu).forEach((sibling) => {
      if (sibling !== item) {
        closeItem(sibling, true);
      }
    });

    syncGluedState(parentMenu);
  }

  function openItem(item, immediate) {
    const trigger = getDirectTrigger(item);
    const menu = getDirectMenu(item);
    if (!trigger || !menu) return;

    clearTimers(item);

    const activate = () => {
      closeSiblingItems(item);
      trigger.setAttribute("aria-expanded", "true");
      item.classList.add("is-dropdown-open");
      menu.setAttribute("aria-hidden", "false");
      updateInverseDirection(menu);
      syncGluedState(item.closest('[data-type="menu"]'));
      syncOpenMenuOverlay();
    };

    if (immediate || item.classList.contains("is-dropdown-open")) {
      activate();
      return;
    }

    item.__silabaHoverOpenTimer = window.setTimeout(() => {
      activate();
      item.__silabaHoverOpenTimer = 0;
    }, OPEN_DELAY);
  }

  function scheduleClose(item, immediate) {
    const trigger = getDirectTrigger(item);
    const menu = getDirectMenu(item);
    if (!trigger || !menu) return;

    clearTimer(item, "__silabaHoverOpenTimer");
    clearTimer(item, "__silabaHoverCloseTimer");

    if (!item.classList.contains("is-dropdown-open") && !immediate) {
      return;
    }

    const deactivate = () => {
      closeItem(item, true);
      item.__silabaHoverCloseTimer = 0;
    };

    if (immediate) {
      deactivate();
      return;
    }

    item.__silabaHoverCloseTimer = window.setTimeout(deactivate, CLOSE_DELAY);
  }

  function closeAll(navRoot) {
    if (!navRoot) return;

    navRoot.querySelectorAll(".nav-bar__item.is-dropdown-open, .nav-dropdown__item.is-dropdown-open").forEach((item) => {
      closeItem(item, true);
    });

    navRoot.querySelectorAll('[data-type="menu"]').forEach((menu) => {
      syncGluedState(menu);
    });

    syncOpenMenuOverlay();
  }

  function bindItem(item) {
    if (!item || item.dataset.silabaHoverBound === "1") return;

    const trigger = getDirectTrigger(item);
    const menu = getDirectMenu(item);
    if (!trigger || !menu) return;

    item.dataset.silabaHoverBound = "1";

    item.addEventListener("mouseenter", () => {
      if (!supportsDesktopHover()) return;
      openItem(item, false);
    });

    item.addEventListener("mouseleave", () => {
      if (!supportsDesktopHover()) return;
      scheduleClose(item, false);
    });

    item.addEventListener("focusin", () => {
      openItem(item, true);
    });

    item.addEventListener("focusout", (event) => {
      if (event.relatedTarget && item.contains(event.relatedTarget)) return;
      scheduleClose(item, false);
    });

    trigger.addEventListener("click", (event) => {
      if (!supportsDesktopHover()) return;

      event.stopPropagation();

      if ((trigger.getAttribute("href") || "").trim() === "#") {
        event.preventDefault();

        if (item.classList.contains("is-dropdown-open")) {
          scheduleClose(item, true);
        } else {
          openItem(item, true);
        }
      }
    });
  }

  function applyNovidadesColor(section) {
    if (!section) return;

    const novidadesButton = Array.from(section.querySelectorAll(".header__quick-button")).find((button) => {
      return /novidades/i.test((button.textContent || "").trim());
    });

    const fallbackBg = getComputedStyle(document.documentElement).getPropertyValue("--accent-color").trim() || "#f04d2b";
    const fallbackText = "#ffffff";

    if (!novidadesButton) {
      section.style.setProperty("--silaba-nav-open-bg", fallbackBg);
      section.style.setProperty("--silaba-nav-open-text", fallbackText);
      return;
    }

    const styles = window.getComputedStyle(novidadesButton);
    section.style.setProperty("--silaba-nav-open-bg", styles.backgroundColor || fallbackBg);
    section.style.setProperty("--silaba-nav-open-text", styles.color || fallbackText);
  }

  function bindHeaderMenu(section) {
    if (!section) return;

    applyNovidadesColor(section);

    const navRoot = section.querySelector(".nav-bar");
    if (!navRoot) return;

    if (typeof MutationObserver === "function" && !section.__silabaHeaderMenuObserver) {
      section.__silabaHeaderMenuObserver = new MutationObserver(() => {
        syncOpenMenuOverlay();
      });

      section.__silabaHeaderMenuObserver.observe(section, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "aria-hidden", "aria-expanded"]
      });
    }

    if (!supportsDesktopHover()) {
      syncOpenMenuOverlay();
      return;
    }

    bindNativeHoverBlocker(navRoot);

    if (navRoot.dataset.silabaHoverNavBound === "1") return;

    navRoot.dataset.silabaHoverNavBound = "1";
    navRoot.querySelectorAll(ITEM_SELECTOR).forEach(bindItem);
    boundNavs.add(navRoot);

  }

  function initHeaderMenus(scope) {
    (scope || document).querySelectorAll(HEADER_SELECTOR).forEach(bindHeaderMenu);
  }

  document.addEventListener(
    "click",
    (event) => {
      boundNavs.forEach((navRoot) => {
        if (!navRoot.isConnected) {
          boundNavs.delete(navRoot);
          return;
        }

        if (!navRoot.contains(event.target)) {
          closeAll(navRoot);
        }
      });
    },
    true
  );

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    boundNavs.forEach((navRoot) => {
      if (!navRoot.isConnected) {
        boundNavs.delete(navRoot);
        return;
      }

      closeAll(navRoot);
    });
  });

  window.addEventListener("resize", () => {
    document.querySelectorAll(HEADER_SELECTOR).forEach((section) => {
      applyNovidadesColor(section);
      bindHeaderMenu(section);
    });

    syncOpenMenuOverlay();
  });

  window.addEventListener("scroll", syncOpenMenuOverlay, { passive: true });

  initHeaderMenus(document);
  syncOpenMenuOverlay();

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section = event.target && event.target.matches && event.target.matches(HEADER_SELECTOR)
        ? event.target
        : event.target && event.target.closest
          ? event.target.closest(HEADER_SELECTOR)
          : null;

      if (section) {
        bindHeaderMenu(section);
      }
    },
    true
  );
})();

(() => {
  const GUARD = "__silaba_catalog_media_normalizer_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  // CSS now keeps catalog media stable. Running canvas-based fitting after paint
  // causes a visible Safari repaint on collection/search pages.
  return;

  const STAGE_SELECTOR = [
    ".template-collection .product-list--collection .product-item--vertical .product-item__image-wrapper .aspect-ratio",
    ".template-search .product-list--collection .product-item--vertical .product-item__image-wrapper .aspect-ratio"
  ].join(", ");
  const TARGET_WIDTH = 0.95;
  const TARGET_HEIGHT = 0.95;
  const MAX_SCALE = 2.1;
  const MOBILE_QUERY = "(max-width: 740px)";

  function isMobileCatalogLayout() {
    return typeof window.matchMedia === "function" && window.matchMedia(MOBILE_QUERY).matches;
  }

  function averageColor(samples) {
    if (!samples.length) return [255, 255, 255];

    let totalR = 0;
    let totalG = 0;
    let totalB = 0;

    samples.forEach((sample) => {
      totalR += sample[0];
      totalG += sample[1];
      totalB += sample[2];
    });

    return [
      Math.round(totalR / samples.length),
      Math.round(totalG / samples.length),
      Math.round(totalB / samples.length)
    ];
  }

  function getPerimeterAverage(data, width, height) {
    const samples = [];
    const step = Math.max(1, Math.floor(Math.min(width, height) / 24));

    for (let x = 0; x < width; x += step) {
      let topIndex = x * 4;
      let bottomIndex = ((height - 1) * width + x) * 4;

      samples.push([data[topIndex], data[topIndex + 1], data[topIndex + 2]]);
      samples.push([data[bottomIndex], data[bottomIndex + 1], data[bottomIndex + 2]]);
    }

    for (let y = 0; y < height; y += step) {
      let leftIndex = (y * width) * 4;
      let rightIndex = (y * width + (width - 1)) * 4;

      samples.push([data[leftIndex], data[leftIndex + 1], data[leftIndex + 2]]);
      samples.push([data[rightIndex], data[rightIndex + 1], data[rightIndex + 2]]);
    }

    return averageColor(samples);
  }

  function detectVisualBounds(image) {
    if (!image || !image.naturalWidth || !image.naturalHeight) return null;

    const maxSample = 160;
    const renderScale = maxSample / Math.max(image.naturalWidth, image.naturalHeight);
    const width = Math.max(24, Math.round(image.naturalWidth * renderScale));
    const height = Math.max(24, Math.round(image.naturalHeight * renderScale));
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d", { willReadFrequently: true });

    if (!context) return null;

    canvas.width = width;
    canvas.height = height;
    context.drawImage(image, 0, 0, width, height);

    const { data } = context.getImageData(0, 0, width, height);
    const [bgR, bgG, bgB] = getPerimeterAverage(data, width, height);
    const threshold = 22;
    let minX = width;
    let minY = height;
    let maxX = -1;
    let maxY = -1;

    for (let y = 0; y < height; y += 1) {
      for (let x = 0; x < width; x += 1) {
        const index = (y * width + x) * 4;
        const alpha = data[index + 3];

        if (alpha < 16) continue;

        const distance =
          Math.abs(data[index] - bgR) +
          Math.abs(data[index + 1] - bgG) +
          Math.abs(data[index + 2] - bgB);

        if (distance < threshold) continue;

        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    }

    if (maxX < minX || maxY < minY) return null;

    return {
      widthRatio: (maxX - minX + 1) / width,
      heightRatio: (maxY - minY + 1) / height,
      centerX: (minX + maxX + 1) / (2 * width),
      centerY: (minY + maxY + 1) / (2 * height)
    };
  }

  function applyStageNormalization(stage) {
    const image = stage.querySelector(".product-item__primary-image");
    if (!image) return;

    const imageKey = image.currentSrc || image.src || "";
    if (stage.dataset.slbMediaNormalized === imageKey && image.complete) return;

    if (!image.complete || !image.naturalWidth) {
      image.addEventListener(
        "load",
        () => {
          applyStageNormalization(stage);
        },
        { once: true }
      );
      return;
    }

    const bounds = detectVisualBounds(image);
    let mediaScale = 1;
    let shiftX = 0;
    let shiftY = 0;
    const isMobile = isMobileCatalogLayout();

    if (isMobile) {
      stage.style.setProperty("--slb-media-scale", "1");
      stage.style.setProperty("--slb-media-shift-x", "0%");
      stage.style.setProperty("--slb-media-shift-y", "0%");
      stage.dataset.slbMediaNormalized = imageKey;
      return;
    }

    if (bounds) {
      const stageRect = stage.getBoundingClientRect();
      const stageRatio = stageRect.width && stageRect.height ? stageRect.width / stageRect.height : 1;
      const imageRatio = image.naturalWidth / image.naturalHeight;
      const renderedWidthRatio = imageRatio >= stageRatio ? 1 : imageRatio / stageRatio;
      const renderedHeightRatio = imageRatio >= stageRatio ? stageRatio / imageRatio : 1;
      const visualWidthInStage = renderedWidthRatio * bounds.widthRatio;
      const visualHeightInStage = renderedHeightRatio * bounds.heightRatio;
      const widthScale = TARGET_WIDTH / Math.max(visualWidthInStage, 0.01);
      const heightScale = TARGET_HEIGHT / Math.max(visualHeightInStage, 0.01);

      mediaScale = Math.min(
        MAX_SCALE,
        Math.max(
          1,
          Math.min(widthScale, heightScale)
        )
      );

      shiftX = (0.5 - bounds.centerX) * 100;
      shiftY = (0.5 - bounds.centerY) * 100;
    }

    stage.style.setProperty("--slb-media-scale", mediaScale.toFixed(3));
    stage.style.setProperty("--slb-media-shift-x", `${shiftX.toFixed(2)}%`);
    stage.style.setProperty("--slb-media-shift-y", `${shiftY.toFixed(2)}%`);
    stage.dataset.slbMediaNormalized = imageKey;
  }

  function normalizeCatalogMedia(root = document) {
    root.querySelectorAll(STAGE_SELECTOR).forEach(applyStageNormalization);
  }

  let frameRequested = false;
  function scheduleNormalize(root = document) {
    if (frameRequested) return;
    frameRequested = true;

    window.requestAnimationFrame(() => {
      frameRequested = false;
      normalizeCatalogMedia(root);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    scheduleNormalize(document);
  });

  window.addEventListener("load", () => {
    scheduleNormalize(document);
  });

  document.addEventListener("shopify:section:load", () => {
    scheduleNormalize(document);
  });

  if (document.body) {
    new MutationObserver(() => {
      scheduleNormalize(document);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

(() => {
  const GUARD = "__silaba_catalog_title_fit_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  // Product card titles are clamped in CSS. JS font fitting mutates font sizes
  // after DOMContentLoaded/load and creates a second visible repaint in Safari.
  return;

  const TITLE_SELECTOR = [
    ".product-list .product-item--vertical .product-item__title"
  ].join(", ");
  const MAX_LINES = 3;
  const MIN_FONT_SIZE = 10;

  function readNumber(value, fallback) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function makeMeasurementNode(title, width, fontSize, lineHeightRatio) {
    const styles = window.getComputedStyle(title);
    const node = document.createElement("span");

    node.textContent = title.textContent || "";
    node.style.position = "absolute";
    node.style.visibility = "hidden";
    node.style.pointerEvents = "none";
    node.style.left = "-9999px";
    node.style.top = "0";
    node.style.width = `${width}px`;
    node.style.boxSizing = styles.boxSizing;
    node.style.display = "block";
    node.style.whiteSpace = "normal";
    node.style.overflow = "visible";
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.wordSpacing = styles.wordSpacing;
    node.style.textTransform = styles.textTransform;
    node.style.fontSize = `${fontSize}px`;
    node.style.lineHeight = `${fontSize * lineHeightRatio}px`;

    return node;
  }

  function fitTitle(title) {
    const width = title.getBoundingClientRect().width;
    if (!width) return;

    title.style.removeProperty("--slb-card-title-fit-font-size");

    const styles = window.getComputedStyle(title);
    const baseFontSize = readNumber(styles.getPropertyValue("--slb-card-title-font-size"), readNumber(styles.fontSize, 16));
    const lineHeightRatio = readNumber(styles.getPropertyValue("--slb-card-title-line-height"), readNumber(styles.lineHeight, baseFontSize * 1.2) / baseFontSize);
    let candidate = baseFontSize;

    while (candidate > MIN_FONT_SIZE) {
      const measurement = makeMeasurementNode(title, width, candidate, lineHeightRatio);
      document.body.appendChild(measurement);

      const maxHeight = candidate * lineHeightRatio * MAX_LINES + 1;
      const fits = measurement.scrollHeight <= maxHeight;
      measurement.remove();

      if (fits) break;
      candidate -= 0.5;
    }

    if (candidate < baseFontSize) {
      title.style.setProperty("--slb-card-title-fit-font-size", `${Math.max(MIN_FONT_SIZE, candidate).toFixed(1)}px`);
    }
  }

  function fitCatalogTitles(root = document) {
    root.querySelectorAll(TITLE_SELECTOR).forEach(fitTitle);
  }

  let frameRequested = false;
  function scheduleFit(root = document) {
    if (frameRequested) return;
    frameRequested = true;

    window.requestAnimationFrame(() => {
      frameRequested = false;
      fitCatalogTitles(root);
    });
  }

  document.addEventListener("DOMContentLoaded", () => scheduleFit(document));
  window.addEventListener("load", () => scheduleFit(document));
  window.addEventListener("resize", () => scheduleFit(document));
  document.addEventListener("shopify:section:load", (event) => scheduleFit(event.target || document));

  if (document.body) {
    new MutationObserver(() => {
      scheduleFit(document);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

(() => {
  const GUARD = "__silaba_desktop_search_scroll_lock_fix_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const DESKTOP_QUERY = "(min-width: 1000px)";

  function isDesktopSearchLayout() {
    return typeof window.matchMedia === "function" && window.matchMedia(DESKTOP_QUERY).matches;
  }

  function releaseDesktopSearchScrollLock() {
    if (!isDesktopSearchLayout()) return;

    const activeSearch = document.querySelector(".header__search-bar-wrapper.is-fixed");
    if (!activeSearch) return;

    document.documentElement.classList.remove("is-locked");
  }

  document.addEventListener("focusin", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest('.header__search-bar-wrapper input[name="q"]')) return;

    window.requestAnimationFrame(releaseDesktopSearchScrollLock);
  });

  window.addEventListener("resize", releaseDesktopSearchScrollLock);
})();

(() => {
  const GUARD = "__silaba_passive_autopen_mini_cart_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  if (typeof Accessibility === "undefined") return;

  const DESKTOP_QUERY = "(min-width: 641px)";

  function isDesktopMiniCartLayout() {
    return typeof window.matchMedia === "function" && window.matchMedia(DESKTOP_QUERY).matches;
  }

  function isElementInViewport(element) {
    if (!(element instanceof Element) || element.getClientRects().length === 0) return false;

    const rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function isHeaderCartVisible(cartInstance) {
    return isElementInViewport(
      cartInstance?.miniCartToggleElement || document.querySelector(".header__cart-toggle")
    );
  }

  function getMiniCartElement() {
    return document.getElementById("mini-cart");
  }

  function getMiniCartToggleElement() {
    return document.querySelector('.header__cart-toggle[aria-controls="mini-cart"]');
  }

  function releasePassiveMiniCartLock() {
    const miniCartElement = getMiniCartElement();
    if (!miniCartElement || !isDesktopMiniCartLayout()) return;

    Accessibility.removeTrapFocus(miniCartElement, "mini-cart");
    document.documentElement.classList.remove("is-locked");
  }

  function isMobileOverlayOpen() {
    return Boolean(
      document.documentElement.classList.contains("slb-mobile-search-open") ||
      document.querySelector('#mobile-menu[aria-hidden="false"]')
    );
  }

  function releaseMobileAddToCartLock() {
    if (isDesktopMiniCartLayout()) return;

    const miniCartElement = getMiniCartElement();
    const miniCartToggleElement = getMiniCartToggleElement();

    if (miniCartElement) {
      miniCartElement.setAttribute("aria-hidden", "true");
      miniCartElement.style.maxHeight = "";
      miniCartElement.querySelector(".mini-cart__content")?.style.removeProperty("max-height");
      Accessibility.removeTrapFocus(miniCartElement, "mini-cart");
    }

    if (miniCartToggleElement) {
      miniCartToggleElement.setAttribute("aria-expanded", "false");
      miniCartToggleElement.querySelector(".header__cart-icon")?.setAttribute("aria-expanded", "false");
    }

    if (!isMobileOverlayOpen()) {
      document.documentElement.classList.remove("is-locked");
    }
  }

  function scheduleMobileAddToCartUnlock() {
    window.setTimeout(releaseMobileAddToCartLock, 0);
    window.setTimeout(releaseMobileAddToCartLock, 120);
    window.setTimeout(releaseMobileAddToCartLock, 500);
  }

  function openMiniCartPassively() {
    const miniCartElement = getMiniCartElement();
    const miniCartToggleElement = getMiniCartToggleElement();

    if (!miniCartElement || !miniCartToggleElement) return;

    if (miniCartElement.getAttribute("aria-hidden") === "true") {
      miniCartToggleElement.click();
    }

    releasePassiveMiniCartLock();
  }

  async function refreshMiniCartMarkup() {
    const cartRoot = document.querySelector(".header__action-item--cart");
    const miniCartElement = getMiniCartElement();

    if (!cartRoot || !miniCartElement) return;

    const response = await fetch(`${window.routes.cartUrl}?section_id=mini-cart`, {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Cache-Control": "no-cache"
      }
    });

    const html = await response.text();
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    const nextMiniCartElement = tempElement.querySelector(".mini-cart");
    if (!nextMiniCartElement) return;

    const itemCount = parseInt(nextMiniCartElement.getAttribute("data-item-count") || "0", 10);
    window.theme.cartCount = itemCount;

    miniCartElement.innerHTML = nextMiniCartElement.innerHTML;
    miniCartElement.setAttribute("data-item-count", `${itemCount}`);

    document.querySelectorAll(".header__cart-count").forEach((node) => {
      node.textContent = `${itemCount}`;
    });

    cartRoot.dispatchEvent(new CustomEvent("cart:rerendered", { bubbles: true }));
  }

  document.addEventListener(
    "product:added",
    async function (event) {
      if (window.theme?.pageType === "cart") return;
      if (window.theme?.cartType !== "drawer") return;
      if (!event.detail?.productAdded) return;

      if (!isDesktopMiniCartLayout()) {
        event.stopPropagation();
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        scheduleMobileAddToCartUnlock();
        return;
      }

      event.stopImmediatePropagation();
      event.stopPropagation();

      try {
        await refreshMiniCartMarkup();
      } catch (error) {
      } finally {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
      }

      if (!isHeaderCartVisible()) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      openMiniCartPassively();
    },
    true
  );
})();

(() => {
  const GUARD = "__silaba_cart_count_sync_all_badges_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const COUNT_SELECTOR = ".header__cart-count";

  function toCount(value, fallback = 0) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function currentDisplayedCount() {
    const node = document.querySelector(COUNT_SELECTOR);
    return toCount(node?.textContent, toCount(window.theme?.cartCount, 0));
  }

  function setCartCount(count) {
    const nextCount = Math.max(0, toCount(count, 0));

    if (window.theme) {
      window.theme.cartCount = nextCount;
    }

    document.querySelectorAll(COUNT_SELECTOR).forEach((node) => {
      node.textContent = `${nextCount}`;
      node.setAttribute("data-cart-count", `${nextCount}`);
    });
  }

  async function refreshCartCount() {
    if (!window.routes?.cartUrl) return;

    const response = await fetch(`${window.routes.cartUrl}.js`, {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    if (!response.ok) return;

    const cart = await response.json();
    setCartCount(cart.item_count);
  }

  function scheduleServerRefresh() {
    window.setTimeout(() => {
      refreshCartCount().catch(() => {});
    }, 120);

    window.setTimeout(() => {
      refreshCartCount().catch(() => {});
    }, 700);
  }

  document.addEventListener("product:added", (event) => {
    if (!event.detail?.productAdded) return;

    const quantity = Math.max(1, toCount(event.detail.quantity, 1));
    setCartCount(currentDisplayedCount() + quantity);
    scheduleServerRefresh();
  }, true);

  document.documentElement.addEventListener("cart:refresh", scheduleServerRefresh, true);
  document.addEventListener("cart:rerendered", scheduleServerRefresh, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setCartCount(toCount(window.theme?.cartCount, currentDisplayedCount())), { once: true });
  } else {
    setCartCount(toCount(window.theme?.cartCount, currentDisplayedCount()));
  }
})();

(() => {
  const GUARD = "__silaba_account_chat_bound_v2__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const SUPPORT_ACTIVE_CLASS = "slb-account-support-active";
  const SUPPORT_ITEM_ACTIVE_CLASS = "is-chat-active";
  let supportCloseWatcher = null;
  let pendingRichpanelContactOpen = false;

  function isVisible(element) {
    if (!element || !element.isConnected) return false;

    const style = window.getComputedStyle(element);
    if (style.display === "none" || style.visibility === "hidden" || Number(style.opacity) === 0) return false;

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function setSupportActive(active) {
    document.documentElement.classList.toggle(SUPPORT_ACTIVE_CLASS, active);

    document.querySelectorAll("[data-slb-open-chat]").forEach((element) => {
      element.classList.toggle(SUPPORT_ITEM_ACTIVE_CLASS, active);
    });
  }

  function isChatPanelVisible() {
    return [
      "#richpanel_messenger_iframe",
      ".richpanel-micro .rp-micro-app-messenger",
      'iframe[src*="richpanel" i]',
      'iframe[title*="richpanel" i]',
      'iframe[title*="chat" i]',
      'iframe[title*="support" i]'
    ].some((selector) => {
      return Array.from(document.querySelectorAll(selector)).some((element) => {
        if (!isVisible(element)) return false;

        const rect = element.getBoundingClientRect();
        return rect.width >= 260 && rect.height >= 220;
      });
    });
  }

  function watchSupportClose() {
    window.clearInterval(supportCloseWatcher);

    const startedAt = Date.now();
    let sawPanel = isChatPanelVisible();

    supportCloseWatcher = window.setInterval(() => {
      const panelVisible = isChatPanelVisible();

      if (panelVisible) {
        sawPanel = true;
        return;
      }

      if (sawPanel || Date.now() - startedAt > 8000) {
        window.clearInterval(supportCloseWatcher);
        supportCloseWatcher = null;
        setSupportActive(false);
      }
    }, 400);
  }

  function dispatchActivationEvents(element) {
    const common = { bubbles: true, cancelable: true, view: window };

    try {
      element.dispatchEvent(new PointerEvent("pointerdown", { ...common, pointerId: 1, pointerType: "mouse", isPrimary: true }));
      element.dispatchEvent(new PointerEvent("pointerup", { ...common, pointerId: 1, pointerType: "mouse", isPrimary: true }));
    } catch (error) {
    }

    element.dispatchEvent(new MouseEvent("mousedown", common));
    element.dispatchEvent(new MouseEvent("mouseup", common));
    element.dispatchEvent(new MouseEvent("click", common));
    element.dispatchEvent(new KeyboardEvent("keydown", { bubbles: true, cancelable: true, key: "Enter", code: "Enter" }));
    element.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true, cancelable: true, key: "Enter", code: "Enter" }));
    element.dispatchEvent(new KeyboardEvent("keydown", { bubbles: true, cancelable: true, key: " ", code: "Space" }));
    element.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true, cancelable: true, key: " ", code: "Space" }));

    if (typeof element.click === "function") {
      element.click();
    }
  }

  function clickFirstAvailable(selectors) {
    for (const selector of selectors) {
      const elements = Array.from(document.querySelectorAll(selector));
      const element = elements.find(isVisible) || elements[0];

      if (!element) continue;

      dispatchActivationEvents(element);
      return true;
    }

    return false;
  }

  function messageFromTrigger(trigger) {
    const base = String(trigger?.getAttribute("data-slb-contact-message") || "").trim();
    if (!base) return "";

    const form = trigger.closest?.('form[action*="/cart/add"]');
    if (!form) return base;

    const select = form.querySelector('select[name="id"]');
    const option = select && select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    if (!option) return base;

    const additions = [];
    const rawVariantTitle = String(option.textContent || "").replace(/\s+/g, " ").trim();
    const priceSeparatorIndex = rawVariantTitle.lastIndexOf(" - ");
    const variantTitle = priceSeparatorIndex >= 0 ? rawVariantTitle.slice(0, priceSeparatorIndex).trim() : rawVariantTitle;
    const sku = String(option.getAttribute("data-sku") || "").trim();

    if (variantTitle && variantTitle !== "Default Title") {
      additions.push(`${trigger.getAttribute("data-slb-variant-label") || "Variant"}: ${variantTitle}`);
    }

    if (sku) {
      additions.push(`${trigger.getAttribute("data-slb-sku-label") || "SKU"}: ${sku}`);
    }

    return additions.length ? `${base}\n${additions.join("\n")}` : base;
  }

  function copyMessageFallback(message) {
    if (!message || !navigator.clipboard || typeof navigator.clipboard.writeText !== "function") return;

    navigator.clipboard.writeText(message).catch(() => {});
  }

  function showRichpanelFrame() {
    let opened = false;

    if (window.RichpanelAppProxy) {
      if (typeof window.RichpanelAppProxy.showTheMessengerFrame === "function") {
        window.RichpanelAppProxy.showTheMessengerFrame();
        opened = true;
      }

      if (typeof window.RichpanelAppProxy.digest === "function") {
        window.RichpanelAppProxy.digest();
      }
    }

    const richpanelFrame = document.getElementById("richpanel_messenger_iframe");
    if (richpanelFrame) {
      richpanelFrame.style.opacity = "1";
      richpanelFrame.style.visibility = "visible";
      return true;
    }

    return opened;
  }

  function getRichpanelAppInstance() {
    try {
      const richpanelFrame = document.getElementById("richpanel_messenger_iframe");
      const richpanelDocument = richpanelFrame?.contentDocument;
      return richpanelDocument?.querySelector(".rp-app")?.__vue__ || null;
    } catch (error) {
      return null;
    }
  }

  function currentRichpanelConversationId() {
    const match = window.location.hash.match(/#rp-customer-widget-conversation_([^#?&]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function findRichpanelConversation(app, conversationId) {
    if (!app || !conversationId) return null;

    return (
      app.conversationsDB?.[conversationId] ||
      app.conversations?.find?.((conversation) => conversation?.id === conversationId) ||
      app.startConversations?.find?.((conversation) => conversation?.id === conversationId || conversation?.conversationId === conversationId) ||
      null
    );
  }

  function openRichpanelHashConversation() {
    const conversationId = currentRichpanelConversationId();
    const app = getRichpanelAppInstance();
    const conversation = findRichpanelConversation(app, conversationId);

    if (!app || !conversation || typeof app.handleConversationClick !== "function") return false;

    if (app.screenType === "conversation" && app.selectedConversationId === conversationId) {
      return true;
    }

    try {
      const result = app.handleConversationClick(conversation);
      if (result && typeof result.catch === "function") {
        result.catch(() => {});
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  function scheduleRichpanelHashConversationOpen(attempt = 0) {
    if (openRichpanelHashConversation()) return;
    if (attempt >= 24) return;

    window.setTimeout(() => scheduleRichpanelHashConversationOpen(attempt + 1), attempt < 6 ? 500 : 750);
  }

  function queueRichpanelConversation(payload) {
    if (!window.RichpanelAppProxy) return false;

    let queued = false;

    if (Array.isArray(window.RichpanelAppProxy.messageQueue)) {
      window.RichpanelAppProxy.messageQueue.push({
        actionName: "CREATE_NEW_CONVERSATION",
        payload
      });
      queued = true;
    }

    if (typeof window.RichpanelAppProxy.loadMessenger === "function") {
      window.RichpanelAppProxy.loadMessenger();
    }

    if (!queued) return false;

    pendingRichpanelContactOpen = true;
    window.setTimeout(() => {
      if (pendingRichpanelContactOpen) {
        showRichpanelFrame();
        scheduleRichpanelHashConversationOpen();
      }
    }, 5000);
    return true;
  }

  function sendRichpanelConversation(payload) {
    if (
      window.RichpanelAppProxy &&
      window.RichpanelAppProxy.isMessengerLoaded &&
      typeof window.RichpanelAppProxy.sendMessageToMessenger === "function"
    ) {
      window.RichpanelAppProxy.sendMessageToMessenger("CREATE_NEW_CONVERSATION", payload);
      pendingRichpanelContactOpen = false;
      window.setTimeout(showRichpanelFrame, 700);
      window.setTimeout(showRichpanelFrame, 1500);
      window.setTimeout(scheduleRichpanelHashConversationOpen, 1200);
      window.setTimeout(scheduleRichpanelHashConversationOpen, 3000);
      return true;
    }

    if (window.RichpanelAppProxy) {
      return queueRichpanelConversation(payload);
    }

    const richpanelFrame = document.getElementById("richpanel_messenger_iframe");
    if (richpanelFrame?.contentWindow) {
      richpanelFrame.contentWindow.postMessage(JSON.stringify({
        actionName: "CREATE_NEW_CONVERSATION",
        payload
      }), "*");
      window.setTimeout(showRichpanelFrame, 700);
      window.setTimeout(showRichpanelFrame, 1500);
      window.setTimeout(scheduleRichpanelHashConversationOpen, 1200);
      window.setTimeout(scheduleRichpanelHashConversationOpen, 3000);
      return true;
    }

    return false;
  }

  function scheduleRichpanelConversation(payload, attempt = 0) {
    if (sendRichpanelConversation(payload)) return;
    if (attempt >= 28) {
      showRichpanelFrame();
      return;
    }

    window.setTimeout(() => scheduleRichpanelConversation(payload, attempt + 1), 250);
  }

  function openRichpanelConversation(message) {
    if (!message) return false;

    const payload = {
      initalMessage: message,
      initialMessage: message
    };

    if (window.RichpanelAppProxy) {
      if (sendRichpanelConversation(payload)) {
        return true;
      }

      if (typeof window.RichpanelAppProxy.loadMessenger === "function") {
        window.RichpanelAppProxy.loadMessenger();
        scheduleRichpanelConversation(payload);
        return true;
      }
    }

    if (sendRichpanelConversation(payload)) {
      return true;
    }

    return false;
  }

  function openChatWidget(message = "") {
    const initialMessage = String(message || "").trim();

    if (initialMessage) {
      return openRichpanelConversation(initialMessage);
    }

    if (window.RichpanelAppProxy && typeof window.RichpanelAppProxy.showMessenger === "function") {
      window.RichpanelAppProxy.showMessenger();
      return true;
    }

    if (window.Richpanel && typeof window.Richpanel.showMessenger === "function") {
      window.Richpanel.showMessenger();
      return true;
    }

    const richpanelFrame = document.getElementById("richpanel_messenger_iframe");
    if (richpanelFrame?.contentWindow) {
      richpanelFrame.style.opacity = "1";
      richpanelFrame.style.visibility = "visible";
      richpanelFrame.contentWindow.postMessage(JSON.stringify({ actionName: "LAUNCH_MESSENGER", payload: {} }), "*");
      if (initialMessage) {
        richpanelFrame.contentWindow.postMessage(JSON.stringify({
          actionName: "CREATE_NEW_CONVERSATION",
          payload: {
            initalMessage: initialMessage,
            initialMessage: initialMessage
          }
        }), "*");
      }
      return true;
    }

    if (window.GorgiasChat && typeof window.GorgiasChat.open === "function") {
      window.GorgiasChat.open();
      return true;
    }

    if (window.tidioChatApi && typeof window.tidioChatApi.open === "function") {
      window.tidioChatApi.open();
      return true;
    }

    if (window.Intercom) {
      window.Intercom("show");
      return true;
    }

    if (window.$crisp) {
      window.$crisp.push(["do", "chat:open"]);
      return true;
    }

    if (window.Reamaze && typeof window.Reamaze.popup === "function") {
      window.Reamaze.popup();
      return true;
    }

    return clickFirstAvailable([
      ".rp-messenger-trigger",
      "[data-rp-messenger-trigger]",
      ".richpanel-micro .rp-micro-app-dummy-icon-container",
      ".richpanel-micro .rp-micro-app-messenger",
      '[class*="messenger-trigger" i]',
      '[class*="chat" i] button',
      '[id*="chat" i] button',
      'iframe[title*="chat" i]'
    ]);
  }

  function openChatWithRetry(message = "", attempt = 0) {
    if (openChatWidget(message)) return;
    if (attempt >= 20) return;

    window.setTimeout(() => openChatWithRetry(message, attempt + 1), 250);
  }

  function controllingElement(popover) {
    if (!popover?.id) return null;

    return Array.from(document.querySelectorAll("[aria-controls]"))
      .find((element) => element.getAttribute("aria-controls") === popover.id) || null;
  }

  function releasePopoverFocus(trigger) {
    const popover = trigger.closest(".popover");
    if (!popover) return;

    const controller = controllingElement(popover);

    if (popover.contains(document.activeElement)) {
      if (controller && isVisible(controller) && typeof controller.focus === "function") {
        controller.focus({ preventScroll: true });
      } else if (document.activeElement && typeof document.activeElement.blur === "function") {
        document.activeElement.blur();
      }
    }

    if (
      popover.getAttribute("aria-hidden") === "false" &&
      controller?.getAttribute("aria-expanded") === "true"
    ) {
      document.dispatchEvent(new CustomEvent("popover:close"));
    }
  }

  function closeValuePicker(trigger) {
    const picker = trigger.closest(".value-picker");
    if (!picker || picker.getAttribute("aria-hidden") === "true") return;

    const closeButton = picker.querySelector('[data-action="close-value-picker"][aria-controls]');
    if (closeButton) {
      closeButton.click();
      if (picker.getAttribute("aria-hidden") === "true") return;
    }

    picker.setAttribute("aria-hidden", "true");
    const opener = document.querySelector(`[data-action="open-value-picker"][aria-controls="${picker.id}"]`);
    if (opener) opener.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("is-locked");
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target?.closest?.("[data-slb-open-chat]");
    if (!trigger) return;

    event.preventDefault();
    const contactMessage = messageFromTrigger(trigger);

    if (contactMessage) {
      copyMessageFallback(contactMessage);
    }

    setSupportActive(true);
    watchSupportClose();
    releasePopoverFocus(trigger);
    closeValuePicker(trigger);
    window.setTimeout(() => openChatWithRetry(contactMessage), 120);
  }, true);

  window.addEventListener("message", (event) => {
    const text = typeof event.data === "string" ? event.data : "";
    if (!/richpanel|messenger|chat/i.test(text)) return;

    if (text === "MESSENGER_LOADED" && pendingRichpanelContactOpen) {
      pendingRichpanelContactOpen = false;
      window.setTimeout(showRichpanelFrame, 1200);
      window.setTimeout(scheduleRichpanelHashConversationOpen, 1800);
      window.setTimeout(scheduleRichpanelHashConversationOpen, 4000);
      return;
    }

    if (!/close|closed|hide|minimize/i.test(text)) return;

    window.setTimeout(() => {
      if (!isChatPanelVisible()) {
        window.clearInterval(supportCloseWatcher);
        supportCloseWatcher = null;
        setSupportActive(false);
      }
    }, 250);
  });

  function shouldOpenChatFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get("open_chat") === "1" ||
      params.get("slb_open_chat") === "1" ||
      window.location.hash === "#open-chat" ||
      window.location.hash === "#support-chat"
    );
  }

  if (shouldOpenChatFromUrl()) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => openChatWithRetry(), { once: true });
    } else {
      openChatWithRetry();
    }
  }

  window.SilabaOpenChat = openChatWithRetry;
})();

(() => {
  const GUARD = "__silaba_customer_validation_i18n_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const FORM_SELECTOR = [
    "#customer_login",
    "#header_customer_login",
    "#recover_customer_password",
    "#create_customer",
    "#activate_customer_password",
    "#reset_customer_password",
    "[data-slb-account-api-form]",
    'section[data-section-type="account"] .modal form'
  ].join(", ");

  const messages = {
    required: window.languages?.customerValidationRequired || "Please fill out this field.",
    email: window.languages?.customerValidationEmail || "Please enter a valid email address.",
    checkbox: window.languages?.customerValidationCheckbox || "Please check this box to continue.",
    select: window.languages?.customerValidationSelect || "Please select an option."
  };

  function isSupportedField(field) {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) {
      return false;
    }

    return !!field.form && field.form.matches(FORM_SELECTOR);
  }

  function getValidationMessage(field) {
    if (!field.validity) return "";

    if (field.validity.valueMissing) {
      if (field instanceof HTMLInputElement && (field.type === "checkbox" || field.type === "radio")) {
        return messages.checkbox;
      }

      if (field instanceof HTMLSelectElement) {
        return messages.select;
      }

      return messages.required;
    }

    if (
      (field.validity.typeMismatch || field.validity.badInput || field.validity.patternMismatch) &&
      field instanceof HTMLInputElement &&
      field.type === "email"
    ) {
      return messages.email;
    }

    return "";
  }

  function resetFieldValidation(field) {
    if (!isSupportedField(field) || typeof field.setCustomValidity !== "function") return;
    field.setCustomValidity("");
  }

  document.addEventListener(
    "invalid",
    (event) => {
      const field = event.target;
      if (!isSupportedField(field) || typeof field.setCustomValidity !== "function") return;

      field.setCustomValidity("");

      const message = getValidationMessage(field);
      if (message) {
        field.setCustomValidity(message);
      }
    },
    true
  );

  document.addEventListener(
    "input",
    (event) => {
      resetFieldValidation(event.target);
    },
    true
  );

  document.addEventListener(
    "change",
    (event) => {
      resetFieldValidation(event.target);
    },
    true
  );
})();

(() => {
  const GUARD = "__silaba_native_app_bridge_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const capacitor = window.Capacitor;
  const isNativeApp = Boolean(
    capacitor &&
    typeof capacitor.isNativePlatform === "function" &&
    capacitor.isNativePlatform()
  );

  if (!isNativeApp) return;

  document.documentElement.classList.add("slb-native-app");

  const plugins = capacitor.Plugins || {};
  const App = plugins.App;
  const PushNotifications = plugins.PushNotifications;
  const platform = typeof capacitor.getPlatform === "function" ? capacitor.getPlatform() : "native";
  const nativeConfig = window.silabaNative || {};
  const pushTokenEndpoint = nativeConfig.pushTokenEndpoint || "/apps/silaba/native/push-token";
  const stockAlertEndpoint = nativeConfig.stockAlertEndpoint || "/apps/silaba/native/stock-alert";
  const tokenStorageKey = "silaba:native:push-token";
  const pushRequestedStorageKey = "silaba:native:push-requested";
  let pushListenersReady = false;
  let lastPushToken = window.localStorage.getItem(tokenStorageKey) || "";

  function routeFromNativeUrl(rawUrl) {
    if (!rawUrl || typeof rawUrl !== "string") return "";

    try {
      const parsed = new URL(rawUrl, window.location.origin);

      if (parsed.protocol === "silaba:") {
        const hostPart = parsed.hostname || "";
        const pathPart = parsed.pathname.replace(/^\/+/, "");
        const route = [hostPart, pathPart].filter(Boolean).join("/");

        if (!route || route === "home") return "/";
        if (route === "account" || route === "cliente") return "/account";
        if (route === "orders" || route === "encomendas") return "/account";
        if (route.startsWith("orders/")) return `/account/orders/${route.split("/").slice(1).join("/")}`;
        if (route.startsWith("products/")) return `/${route}`;
        if (route.startsWith("collections/")) return `/${route}`;
        if (route.startsWith("search")) return `/${route}`;
        return `/${route}`;
      }

      if (parsed.origin === window.location.origin) {
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
      }

      if (/(\.|^)silaba\.pt$/i.test(parsed.hostname) || /shopifypreview\.com$/i.test(parsed.hostname)) {
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
      }

      return rawUrl;
    } catch (error) {
      return rawUrl.charAt(0) === "/" ? rawUrl : "";
    }
  }

  function navigateNativeUrl(rawUrl) {
    const route = routeFromNativeUrl(rawUrl);
    if (!route) return;

    window.location.assign(route);
  }

  function getNotificationTarget(notification) {
    const data = notification?.notification?.data || notification?.data || {};
    return data.url || data.path || data.deeplink || data.deepLink || data.link || "";
  }

  function getSelectedVariantId(button) {
    const productForm = button?.closest(".product-form") || document.querySelector(".product-form");
    return productForm?.querySelector('select[name="id"], input[name="id"]')?.value || button?.dataset.variantId || "";
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(payload)
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      return response.text().then((text) => {
        if (!text) return {};
        try {
          return JSON.parse(text);
        } catch (error) {
          return { ok: true };
        }
      });
    });
  }

  function buildDevicePayload(extra = {}) {
    return {
      token: lastPushToken,
      platform,
      appId: "pt.silaba.mobile",
      locale: document.documentElement.lang || navigator.language || "pt",
      pageType: window.theme?.pageType || "",
      customer: window.silabaCustomer || { loggedIn: false, id: null },
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      ...extra
    };
  }

  async function sendPushToken(extra = {}) {
    if (!lastPushToken) return false;

    try {
      await postJson(pushTokenEndpoint, buildDevicePayload(extra));
      document.dispatchEvent(new CustomEvent("silaba:native-push-token-synced", { detail: { token: lastPushToken } }));
      return true;
    } catch (error) {
      document.dispatchEvent(new CustomEvent("silaba:native-push-token-sync-failed", { detail: { error } }));
      return false;
    }
  }

  async function ensurePushListeners() {
    if (!PushNotifications || pushListenersReady) return;
    pushListenersReady = true;

    if (platform === "android" && typeof PushNotifications.createChannel === "function") {
      try {
        await PushNotifications.createChannel({
          id: "silaba_updates",
          name: "Atualizações Sílaba",
          description: "Encomendas, alertas de stock e novidades relevantes.",
          importance: 4,
          visibility: 1
        });
      } catch (error) {
      }
    }

    PushNotifications.addListener("registration", (token) => {
      lastPushToken = token?.value || "";
      if (!lastPushToken) return;

      window.localStorage.setItem(tokenStorageKey, lastPushToken);
      sendPushToken({ reason: "registration" });
    });

    PushNotifications.addListener("registrationError", (error) => {
      document.dispatchEvent(new CustomEvent("silaba:native-push-registration-error", { detail: error }));
    });

    PushNotifications.addListener("pushNotificationReceived", (notification) => {
      document.dispatchEvent(new CustomEvent("silaba:native-push-received", { detail: notification }));
    });

    PushNotifications.addListener("pushNotificationActionPerformed", (notification) => {
      navigateNativeUrl(getNotificationTarget(notification));
    });
  }

  async function enableNotifications(context = "manual", extra = {}) {
    if (!PushNotifications) {
      throw new Error("PushNotifications plugin is not available.");
    }

    await ensurePushListeners();

    let permissions = await PushNotifications.checkPermissions();

    if (permissions.receive === "prompt") {
      permissions = await PushNotifications.requestPermissions();
    }

    if (permissions.receive !== "granted") {
      throw new Error("Notifications permission was not granted.");
    }

    window.localStorage.setItem(pushRequestedStorageKey, "1");
    await PushNotifications.register();

    if (lastPushToken) {
      await sendPushToken({ reason: context, ...extra });
    }

    return { granted: true, token: lastPushToken };
  }

  async function restoreNativeLaunchLinks() {
    if (!App) return;

    App.addListener("appUrlOpen", (event) => {
      navigateNativeUrl(event?.url);
    });

    App.addListener("appStateChange", (state) => {
      if (state?.isActive && lastPushToken) {
        sendPushToken({ reason: "resume" });
      }
    });

    try {
      const launchUrl = await App.getLaunchUrl();
      if (launchUrl?.url) {
        navigateNativeUrl(launchUrl.url);
      }
    } catch (error) {
    }
  }

  function createNativePanel() {
    const panel = document.createElement("div");
    panel.className = "slb-native-app-panel slb-native-app-panel--account";
    panel.innerHTML = `
      <p class="slb-native-app-panel__eyebrow">App Sílaba</p>
      <h2 class="slb-native-app-panel__title">Área de cliente com alertas nativos</h2>
      <p class="slb-native-app-panel__text">Receba atualizações de encomendas e alertas de stock diretamente no telemóvel.</p>
      <div class="slb-native-app-panel__actions">
        <button type="button" class="slb-native-app-panel__button" data-native-enable-notifications>Ativar notificações</button>
        <a class="slb-native-app-panel__button slb-native-app-panel__button--secondary" href="/account">Ver encomendas</a>
      </div>
      <p class="slb-native-app-panel__status" data-native-panel-status></p>
    `;
    return panel;
  }

  function mountAccountPanel() {
    if (!/\/account(?:\/|$)|\/orders(?:\/|$)/.test(window.location.pathname)) return;
    if (document.querySelector(".slb-native-app-panel--account")) return;

    const container =
      document.querySelector('section[data-section-type="account"] .container') ||
      document.querySelector('section[data-section-type="account"]') ||
      document.querySelector("main .container") ||
      document.querySelector("main");

    if (!container) return;

    container.insertBefore(createNativePanel(), container.firstElementChild);
  }

  function setPanelStatus(button, text) {
    const panel = button?.closest(".slb-native-app-panel");
    const status = panel?.querySelector("[data-native-panel-status]");
    if (status) status.textContent = text;
  }

  document.addEventListener("click", async (event) => {
    const enableButton = event.target.closest("[data-native-enable-notifications]");
    if (!enableButton) return;

    event.preventDefault();
    enableButton.disabled = true;
    setPanelStatus(enableButton, "A pedir autorização...");

    try {
      await enableNotifications("account-orders");
      enableButton.textContent = "Notificações ativas";
      setPanelStatus(enableButton, "Vamos usar este dispositivo para alertas de encomendas e stock.");
    } catch (error) {
      enableButton.disabled = false;
      setPanelStatus(enableButton, "Não foi possível ativar as notificações neste dispositivo.");
    }
  }, true);

  document.addEventListener("click", async (event) => {
    const stockButton = event.target.closest("[data-native-stock-alert]");
    if (!stockButton) return;

    event.preventDefault();
    stockButton.disabled = true;

    const originalText = stockButton.textContent;
    const variantId = getSelectedVariantId(stockButton);
    const payload = {
      reason: "stock-alert",
      product: {
        id: stockButton.dataset.productId || "",
        handle: stockButton.dataset.productHandle || "",
        title: stockButton.dataset.productTitle || "",
        variantId,
        sku: stockButton.dataset.variantSku || ""
      }
    };

    try {
      stockButton.textContent = "A ativar alerta...";
      await enableNotifications("stock-alert", payload);
      await postJson(stockAlertEndpoint, buildDevicePayload(payload));
      stockButton.textContent = "Alerta de stock ativo";
    } catch (error) {
      stockButton.disabled = false;
      stockButton.textContent = originalText;
      window.alert("Não foi possível ativar o alerta de stock. Tente novamente mais tarde.");
    }
  }, true);

  if (window.localStorage.getItem(pushRequestedStorageKey) === "1") {
    ensurePushListeners()
      .then(() => PushNotifications?.register?.())
      .catch(() => {});
  }

  restoreNativeLaunchLinks();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountAccountPanel, { once: true });
  } else {
    mountAccountPanel();
  }

  document.addEventListener("shopify:section:load", mountAccountPanel);

  window.SilabaNativeApp = {
    enableNotifications,
    navigateNativeUrl,
    sendPushToken
  };
})();

(() => {
  const GUARD = "__silaba_mobile_account_picker_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const GLOBAL_PICKER_ID = "global-account-selector";
  const ACCOUNT_PICKER_IDS = [GLOBAL_PICKER_ID];
  const ACCOUNT_PICKER_OPEN_CLASS = "slb-account-picker-open";
  const MOBILE_PICKER_MEDIA = window.matchMedia("(max-width: 640px)");

  function globalPickerParts() {
    const picker = document.getElementById(GLOBAL_PICKER_ID);
    const toggle = document.querySelector(`[data-action="open-value-picker"][aria-controls="${GLOBAL_PICKER_ID}"]`);

    if (!picker || !toggle) return null;

    return { picker, toggle };
  }

  function setHeaderZIndex(value) {
    const headerElement = document.querySelector(".shopify-section__header");
    if (headerElement) headerElement.style.zIndex = value || "";
  }

  function isAccountPickerOpen() {
    return ACCOUNT_PICKER_IDS.some((id) => {
      const picker = document.getElementById(id);
      return picker && picker.getAttribute("aria-hidden") === "false";
    });
  }

  function syncAccountPickerState() {
    const isOpen = MOBILE_PICKER_MEDIA.matches && isAccountPickerOpen();

    document.documentElement.classList.toggle(ACCOUNT_PICKER_OPEN_CLASS, isOpen);
    setHeaderZIndex(isOpen ? "2147483010" : "");
  }

  function closeMobileMenu() {
    const menu = document.getElementById("mobile-menu");
    if (!menu || menu.getAttribute("aria-hidden") === "true") return;

    menu.setAttribute("aria-hidden", "true");

    document.querySelectorAll('[data-action="toggle-menu"][aria-controls="mobile-menu"]').forEach((toggle) => {
      toggle.setAttribute("aria-expanded", "false");
    });

    menu.querySelectorAll('[aria-expanded="true"]').forEach((toggle) => {
      toggle.setAttribute("aria-expanded", "false");
    });
  }

  function observeAccountPickers() {
    ACCOUNT_PICKER_IDS.forEach((id) => {
      const picker = document.getElementById(id);
      if (!picker) return;

      new MutationObserver(syncAccountPickerState).observe(picker, {
        attributes: true,
        attributeFilter: ["aria-hidden"]
      });
    });
  }

  function openGlobalPicker() {
    const parts = globalPickerParts();
    if (!parts) return false;

    closeMobileMenu();
    parts.toggle.setAttribute("aria-expanded", "true");
    parts.picker.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("is-locked");
    syncAccountPickerState();

    const firstAction = parts.picker.querySelector(".slb-account-mobile-card, .slb-account-mobile-logout");
    if (firstAction && typeof firstAction.focus === "function") {
      window.setTimeout(() => firstAction.focus({ preventScroll: true }), 0);
    }

    return true;
  }

  function closeGlobalPicker() {
    const parts = globalPickerParts();
    if (!parts || parts.picker.getAttribute("aria-hidden") === "true") return false;

    parts.toggle.setAttribute("aria-expanded", "false");
    parts.picker.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("is-locked");
    syncAccountPickerState();

    return true;
  }

  document.addEventListener("click", (event) => {
    const accountLink = event.target.closest("[data-slb-open-account-selector]");
    if (!accountLink) return;
    if (!MOBILE_PICKER_MEDIA.matches) return;

    const parts = globalPickerParts();
    if (!parts) return;

    const toggled = parts.picker.getAttribute("aria-hidden") === "false" ? closeGlobalPicker() : openGlobalPicker();
    if (!toggled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener("click", (event) => {
    const globalClose = event.target.closest(`[data-action="close-value-picker"][aria-controls="${GLOBAL_PICKER_ID}"]`);
    if (globalClose) {
      event.preventDefault();
      closeGlobalPicker();
      return;
    }

    const parts = globalPickerParts();
    if (!parts || parts.picker.getAttribute("aria-hidden") !== "false") return;
    if (event.target.closest(`#${GLOBAL_PICKER_ID} .value-picker__inner`)) return;
    if (event.target.closest("[data-slb-open-account-selector]")) return;

    closeGlobalPicker();
  }, true);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeGlobalPicker();
    }
  });

  observeAccountPickers();
  syncAccountPickerState();
})();

(() => {
  const GUARD = "__silaba_cart_discount_v2__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  function cartBaseUrl() {
    return (window.routes?.cartUrl || "/cart").replace(/\/$/, "");
  }

  function cartJsonUrl() {
    return `${cartBaseUrl()}.js`;
  }

  function cartUpdateUrl() {
    return `${cartBaseUrl()}/update.js`;
  }

  function splitCodes(value) {
    return String(value || "")
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);
  }

  function codeKey(value) {
    return String(value || "").trim().toLowerCase();
  }

  function uniqueCodes(codes) {
    const seen = new Set();

    return codes.filter((code) => {
      const key = codeKey(code);
      if (!key || seen.has(key)) return false;

      seen.add(key);
      return true;
    });
  }

  function extractValidDiscountCodes(cart) {
    return uniqueCodes((cart?.discount_codes || [])
      .filter((discount) => discount && discount.applicable !== false)
      .map((discount) => typeof discount === "string" ? discount : discount.code)
      .filter(Boolean));
  }

  function isDiscountCodeApplicable(cart, code) {
    const key = codeKey(code);

    if (!key) return false;

    if ((cart?.discount_codes || []).some((discount) => {
      const discountCode = typeof discount === "string" ? discount : discount?.code;
      return codeKey(discountCode) === key && discount?.applicable !== false;
    })) {
      return true;
    }

    return (cart?.cart_level_discount_applications || []).some((discount) => codeKey(discount?.title) === key);
  }

  async function readCart() {
    const response = await fetch(cartJsonUrl(), {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    if (!response.ok) throw new Error("cart_read_failed");

    return response.json();
  }

  async function updateDiscountCodes(codes) {
    const response = await fetch(cartUpdateUrl(), {
      body: JSON.stringify({ discount: uniqueCodes(codes).join(",") }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    if (!response.ok) throw new Error("discount_update_failed");

    return response.json();
  }

  function setMessage(root, message, isError) {
    const node = root.querySelector("[data-slb-cart-discount-message]");
    if (!node) return;

    node.textContent = message || "";
    node.hidden = !message;
    node.classList.toggle("is-error", Boolean(isError));
  }

  function setLoading(root, isLoading) {
    const button = root.querySelector("[data-slb-cart-discount-apply]");
    const input = root.querySelector("[data-slb-cart-discount-input]");
    if (!button) return;

    if (isLoading) {
      button.dataset.originalLabel = button.textContent;
      button.textContent = root.dataset.loadingLabel || button.textContent;
    } else if (button.dataset.originalLabel) {
      button.textContent = button.dataset.originalLabel;
      delete button.dataset.originalLabel;
    }

    button.disabled = isLoading;
    if (input) input.disabled = isLoading;
    root.setAttribute("aria-busy", isLoading ? "true" : "false");
  }

  async function applyDiscount(root) {
    const input = root.querySelector("[data-slb-cart-discount-input]");
    const submittedCodes = splitCodes(input?.value);

    if (!submittedCodes.length) {
      setMessage(root, root.dataset.emptyMessage || "", true);
      input?.focus();
      return;
    }

    setMessage(root, "", false);
    setLoading(root, true);

    let previousCodes = [];

    try {
      const currentCart = await readCart();
      previousCodes = extractValidDiscountCodes(currentCart);
      const nextCodes = uniqueCodes([...previousCodes, ...submittedCodes]);
      const updatedCart = await updateDiscountCodes(nextCodes);

      if (!submittedCodes.every((code) => isDiscountCodeApplicable(updatedCart, code))) {
        await updateDiscountCodes(previousCodes).catch(() => {});
        setMessage(root, root.dataset.invalidMessage || "", true);
        setLoading(root, false);
        input?.focus();
        input?.select();
        return;
      }

      window.location.reload();
    } catch (error) {
      if (previousCodes.length) {
        await updateDiscountCodes(previousCodes).catch(() => {});
      }

      setMessage(root, root.dataset.errorMessage || "", true);
      setLoading(root, false);
    }
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-slb-cart-discount-apply]");
    if (!button) return;

    const root = button.closest("[data-slb-cart-discount]");
    if (!root) return;

    event.preventDefault();
    applyDiscount(root);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter") return;

    const input = event.target.closest("[data-slb-cart-discount-input]");
    if (!input) return;

    const root = input.closest("[data-slb-cart-discount]");
    if (!root) return;

    event.preventDefault();
    applyDiscount(root);
  });
})();

(() => {
  const GUARD = "__silaba_back_to_top_v1__";
  if (window[GUARD]) return;
  window[GUARD] = true;

  const BUTTON_SELECTOR = "[data-slb-back-to-top]";
  const HEADER_SELECTOR = '[data-section-type="header"]';
  const VISIBLE_CLASS = "is-visible";
  const MIN_SCROLL = 160;

  let headerVisible = true;
  let ticking = false;

  function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function getButton() {
    return document.querySelector(BUTTON_SELECTOR);
  }

  function setButtonState(button, visible) {
    button.classList.toggle(VISIBLE_CLASS, visible);
    button.setAttribute("aria-hidden", visible ? "false" : "true");

    if (visible) {
      button.removeAttribute("tabindex");
    } else {
      button.setAttribute("tabindex", "-1");
    }
  }

  function shouldShow() {
    return getScrollTop() > MIN_SCROLL && !headerVisible;
  }

  function updateButton() {
    ticking = false;

    const button = getButton();
    if (!button) return;

    setButtonState(button, shouldShow());
  }

  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateButton);
  }

  function syncHeaderVisibilityWithoutObserver() {
    const header = document.querySelector(HEADER_SELECTOR);

    if (!header) {
      headerVisible = getScrollTop() < MIN_SCROLL;
      scheduleUpdate();
      return;
    }

    const rect = header.getBoundingClientRect();
    headerVisible = rect.bottom > 0 && rect.top < window.innerHeight;
    scheduleUpdate();
  }

  function setupHeaderObserver() {
    const header = document.querySelector(HEADER_SELECTOR);

    if (!header || typeof window.IntersectionObserver !== "function") {
      syncHeaderVisibilityWithoutObserver();
      window.addEventListener("scroll", syncHeaderVisibilityWithoutObserver, { passive: true });
      window.addEventListener("resize", syncHeaderVisibilityWithoutObserver);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      headerVisible = entries.some((entry) => entry.isIntersecting);
      scheduleUpdate();
    }, { threshold: 0.01 });

    observer.observe(header);
  }

  function scrollToTop() {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? "auto" : "smooth"
    });
  }

  function initBackToTop() {
    const button = getButton();
    if (!button) return;

    button.addEventListener("click", (event) => {
      event.preventDefault();
      scrollToTop();
    });

    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);
    window.addEventListener("pageshow", scheduleUpdate);

    setupHeaderObserver();
    scheduleUpdate();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBackToTop, { once: true });
  } else {
    initBackToTop();
  }
})();
